// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAccountOrderDto,
  IAccountOrderMatrixDto,
  IAggregatedAccountActivityDto,
  IAggregatedEmployeeLinkedAccountsDto,
  IAggregatorManualContributionRequestDto,
  IAutoInvestmentSchedulerRequestDto,
  IAutoInvestmentSchedulerResponseDto,
  IAutoInvestmentSchedulerUpdateDto,
  IBalanceReminderResponseDto,
  IBankingActivityDetails,
  ICardPurseDto,
  ICarrierConfigResponseAggregatorDto,
  ICarrierConfigResponseAggregatorDtoPage,
  ICheckReissueDto,
  ICheckVoidDto,
  IChecksResponseAggregatorDtoPage,
  ICipIdologyResponseDto,
  IClaimActivityDetails,
  IClaimInfoAggregatorResponseDto,
  IClaimInfoResponseDto,
  IClaimRejectedAggregatorDto,
  IClaimRepaymentAggregatedDto,
  IClaimRepaymentStartDto,
  IClaimTransferAccountDto,
  IClaimTransferCreateBatchDto,
  IClaimsResponseAggregatorDtoPage,
  IContributionRequestInfoAggregateDto,
  IContributionSegmentResponseDto,
  ICoverageDto,
  ICreateCarrierConfigAggregatorDto,
  ICreateClaimAggregatorDto,
  ICreateDebitCardRequest,
  ICreateDocumentAggregatorDto,
  ICreateProviderAggregatorDto,
  IDependentInfoDto,
  IDependentRequestDto,
  IDependentResponseDto,
  IDependentUpdateDto,
  IDocumentIdDto,
  IEeContributionRequestDto,
  IEeContributionResponseDto,
  IEmployeeBadRecordRequestDto,
  IEmployeeContributionLimitResponse,
  IEmployeeInfoCreateAggregatorDto,
  IEmployeeInfoResponseDto,
  IEmployeeInfoUpdateDto,
  IEmployeeMatchDetailsAggregatorDto,
  IEmployerTerminationPropertiesCreateDto,
  IEmployerTerminationPropertiesDto,
  IEmployerTerminationPropertiesV3Dto,
  IEnrollmentDto,
  IEnrollmentMatrixDto,
  IEnrollmentRecordDto,
  IErrorDto,
  IExpressSetupDto,
  IExpressSetupExtendedDto,
  IFileActorDto,
  IFileDetailsAggregatorResponseDto,
  IFileRecordErrorAggregatorDto,
  IFiservCardVaultToken,
  IFundingPatchDto,
  IHealthPlanCreateDto,
  IHealthPlanDto,
  IHealthPlanUpdateDto,
  IInvestmentHoldingsDto,
  IInvestmentModelSwitchDto,
  IInvestmentOperationRequestDto,
  IInvestorDto,
  IInvoiceDashboardPageDto,
  IInvoiceDetailsAggregatorDto,
  IInvoiceType,
  ILockboxDetailsAggregatorDto,
  ILockboxDto,
  IMonitorContributionAggregateResponseDto,
  IOcrClaimDto,
  IOrganizationExpressSetupResponseDto,
  IOrganizationInfoDto,
  IOrganizationLockDto,
  IPatchLinkedSystemTemplatesDto,
  IPaymentAccountRequestDto,
  IPaymentAccountResponseDto,
  IPaymentDetailsResponseDto,
  IPaymentMethodResponseDto,
  IPaymentMethodSetupRequestDto,
  IPaymentMethodSetupResponseDto,
  IPayrollCalendarAggregatorResponseDto,
  IPayrollCalendarExtendedAggregatorResponseDto,
  IPlanDto,
  IPlanYearDto,
  IPrefundSummaryDto,
  IPrivateClaimInfoResponseDto,
  IProcessEnrollmentRequestDto,
  IProcessingRuleDto,
  IProviderInfoDto,
  IQrCodeOverridablePropertiesDto,
  IRecurringContributionAggregateResponseDto,
  IRecurringContributionAggregatorRequestDto,
  IRecurringContributionPatchUpdateRequestDto,
  IRecurringContributionResponseDto,
  IRelatedClaimEnhancedDto,
  IRenewalRecordDto,
  IRenewalRecordExtendedDto,
  IRetryClaimPaymentDto,
  ISequenceDto,
  ISignUpRequestDto,
  ITradeCreateDto,
  IUpdateLockboxAggregatorDto,
  IUpdatePaymentMethodRequestDto,
} from '../models/index';
import {
    IAccountOrderDtoFromJSON,
    IAccountOrderDtoToJSON,
    IAccountOrderMatrixDtoFromJSON,
    IAccountOrderMatrixDtoToJSON,
    IAggregatedAccountActivityDtoFromJSON,
    IAggregatedAccountActivityDtoToJSON,
    IAggregatedEmployeeLinkedAccountsDtoFromJSON,
    IAggregatedEmployeeLinkedAccountsDtoToJSON,
    IAggregatorManualContributionRequestDtoFromJSON,
    IAggregatorManualContributionRequestDtoToJSON,
    IAutoInvestmentSchedulerRequestDtoFromJSON,
    IAutoInvestmentSchedulerRequestDtoToJSON,
    IAutoInvestmentSchedulerResponseDtoFromJSON,
    IAutoInvestmentSchedulerResponseDtoToJSON,
    IAutoInvestmentSchedulerUpdateDtoFromJSON,
    IAutoInvestmentSchedulerUpdateDtoToJSON,
    IBalanceReminderResponseDtoFromJSON,
    IBalanceReminderResponseDtoToJSON,
    IBankingActivityDetailsFromJSON,
    IBankingActivityDetailsToJSON,
    ICardPurseDtoFromJSON,
    ICardPurseDtoToJSON,
    ICarrierConfigResponseAggregatorDtoFromJSON,
    ICarrierConfigResponseAggregatorDtoToJSON,
    ICarrierConfigResponseAggregatorDtoPageFromJSON,
    ICarrierConfigResponseAggregatorDtoPageToJSON,
    ICheckReissueDtoFromJSON,
    ICheckReissueDtoToJSON,
    ICheckVoidDtoFromJSON,
    ICheckVoidDtoToJSON,
    IChecksResponseAggregatorDtoPageFromJSON,
    IChecksResponseAggregatorDtoPageToJSON,
    ICipIdologyResponseDtoFromJSON,
    ICipIdologyResponseDtoToJSON,
    IClaimActivityDetailsFromJSON,
    IClaimActivityDetailsToJSON,
    IClaimInfoAggregatorResponseDtoFromJSON,
    IClaimInfoAggregatorResponseDtoToJSON,
    IClaimInfoResponseDtoFromJSON,
    IClaimInfoResponseDtoToJSON,
    IClaimRejectedAggregatorDtoFromJSON,
    IClaimRejectedAggregatorDtoToJSON,
    IClaimRepaymentAggregatedDtoFromJSON,
    IClaimRepaymentAggregatedDtoToJSON,
    IClaimRepaymentStartDtoFromJSON,
    IClaimRepaymentStartDtoToJSON,
    IClaimTransferAccountDtoFromJSON,
    IClaimTransferAccountDtoToJSON,
    IClaimTransferCreateBatchDtoFromJSON,
    IClaimTransferCreateBatchDtoToJSON,
    IClaimsResponseAggregatorDtoPageFromJSON,
    IClaimsResponseAggregatorDtoPageToJSON,
    IContributionRequestInfoAggregateDtoFromJSON,
    IContributionRequestInfoAggregateDtoToJSON,
    IContributionSegmentResponseDtoFromJSON,
    IContributionSegmentResponseDtoToJSON,
    ICoverageDtoFromJSON,
    ICoverageDtoToJSON,
    ICreateCarrierConfigAggregatorDtoFromJSON,
    ICreateCarrierConfigAggregatorDtoToJSON,
    ICreateClaimAggregatorDtoFromJSON,
    ICreateClaimAggregatorDtoToJSON,
    ICreateDebitCardRequestFromJSON,
    ICreateDebitCardRequestToJSON,
    ICreateDocumentAggregatorDtoFromJSON,
    ICreateDocumentAggregatorDtoToJSON,
    ICreateProviderAggregatorDtoFromJSON,
    ICreateProviderAggregatorDtoToJSON,
    IDependentInfoDtoFromJSON,
    IDependentInfoDtoToJSON,
    IDependentRequestDtoFromJSON,
    IDependentRequestDtoToJSON,
    IDependentResponseDtoFromJSON,
    IDependentResponseDtoToJSON,
    IDependentUpdateDtoFromJSON,
    IDependentUpdateDtoToJSON,
    IDocumentIdDtoFromJSON,
    IDocumentIdDtoToJSON,
    IEeContributionRequestDtoFromJSON,
    IEeContributionRequestDtoToJSON,
    IEeContributionResponseDtoFromJSON,
    IEeContributionResponseDtoToJSON,
    IEmployeeBadRecordRequestDtoFromJSON,
    IEmployeeBadRecordRequestDtoToJSON,
    IEmployeeContributionLimitResponseFromJSON,
    IEmployeeContributionLimitResponseToJSON,
    IEmployeeInfoCreateAggregatorDtoFromJSON,
    IEmployeeInfoCreateAggregatorDtoToJSON,
    IEmployeeInfoResponseDtoFromJSON,
    IEmployeeInfoResponseDtoToJSON,
    IEmployeeInfoUpdateDtoFromJSON,
    IEmployeeInfoUpdateDtoToJSON,
    IEmployeeMatchDetailsAggregatorDtoFromJSON,
    IEmployeeMatchDetailsAggregatorDtoToJSON,
    IEmployerTerminationPropertiesCreateDtoFromJSON,
    IEmployerTerminationPropertiesCreateDtoToJSON,
    IEmployerTerminationPropertiesDtoFromJSON,
    IEmployerTerminationPropertiesDtoToJSON,
    IEmployerTerminationPropertiesV3DtoFromJSON,
    IEmployerTerminationPropertiesV3DtoToJSON,
    IEnrollmentDtoFromJSON,
    IEnrollmentDtoToJSON,
    IEnrollmentMatrixDtoFromJSON,
    IEnrollmentMatrixDtoToJSON,
    IEnrollmentRecordDtoFromJSON,
    IEnrollmentRecordDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExpressSetupDtoFromJSON,
    IExpressSetupDtoToJSON,
    IExpressSetupExtendedDtoFromJSON,
    IExpressSetupExtendedDtoToJSON,
    IFileActorDtoFromJSON,
    IFileActorDtoToJSON,
    IFileDetailsAggregatorResponseDtoFromJSON,
    IFileDetailsAggregatorResponseDtoToJSON,
    IFileRecordErrorAggregatorDtoFromJSON,
    IFileRecordErrorAggregatorDtoToJSON,
    IFiservCardVaultTokenFromJSON,
    IFiservCardVaultTokenToJSON,
    IFundingPatchDtoFromJSON,
    IFundingPatchDtoToJSON,
    IHealthPlanCreateDtoFromJSON,
    IHealthPlanCreateDtoToJSON,
    IHealthPlanDtoFromJSON,
    IHealthPlanDtoToJSON,
    IHealthPlanUpdateDtoFromJSON,
    IHealthPlanUpdateDtoToJSON,
    IInvestmentHoldingsDtoFromJSON,
    IInvestmentHoldingsDtoToJSON,
    IInvestmentModelSwitchDtoFromJSON,
    IInvestmentModelSwitchDtoToJSON,
    IInvestmentOperationRequestDtoFromJSON,
    IInvestmentOperationRequestDtoToJSON,
    IInvestorDtoFromJSON,
    IInvestorDtoToJSON,
    IInvoiceDashboardPageDtoFromJSON,
    IInvoiceDashboardPageDtoToJSON,
    IInvoiceDetailsAggregatorDtoFromJSON,
    IInvoiceDetailsAggregatorDtoToJSON,
    IInvoiceTypeFromJSON,
    IInvoiceTypeToJSON,
    ILockboxDetailsAggregatorDtoFromJSON,
    ILockboxDetailsAggregatorDtoToJSON,
    ILockboxDtoFromJSON,
    ILockboxDtoToJSON,
    IMonitorContributionAggregateResponseDtoFromJSON,
    IMonitorContributionAggregateResponseDtoToJSON,
    IOcrClaimDtoFromJSON,
    IOcrClaimDtoToJSON,
    IOrganizationExpressSetupResponseDtoFromJSON,
    IOrganizationExpressSetupResponseDtoToJSON,
    IOrganizationInfoDtoFromJSON,
    IOrganizationInfoDtoToJSON,
    IOrganizationLockDtoFromJSON,
    IOrganizationLockDtoToJSON,
    IPatchLinkedSystemTemplatesDtoFromJSON,
    IPatchLinkedSystemTemplatesDtoToJSON,
    IPaymentAccountRequestDtoFromJSON,
    IPaymentAccountRequestDtoToJSON,
    IPaymentAccountResponseDtoFromJSON,
    IPaymentAccountResponseDtoToJSON,
    IPaymentDetailsResponseDtoFromJSON,
    IPaymentDetailsResponseDtoToJSON,
    IPaymentMethodResponseDtoFromJSON,
    IPaymentMethodResponseDtoToJSON,
    IPaymentMethodSetupRequestDtoFromJSON,
    IPaymentMethodSetupRequestDtoToJSON,
    IPaymentMethodSetupResponseDtoFromJSON,
    IPaymentMethodSetupResponseDtoToJSON,
    IPayrollCalendarAggregatorResponseDtoFromJSON,
    IPayrollCalendarAggregatorResponseDtoToJSON,
    IPayrollCalendarExtendedAggregatorResponseDtoFromJSON,
    IPayrollCalendarExtendedAggregatorResponseDtoToJSON,
    IPlanDtoFromJSON,
    IPlanDtoToJSON,
    IPlanYearDtoFromJSON,
    IPlanYearDtoToJSON,
    IPrefundSummaryDtoFromJSON,
    IPrefundSummaryDtoToJSON,
    IPrivateClaimInfoResponseDtoFromJSON,
    IPrivateClaimInfoResponseDtoToJSON,
    IProcessEnrollmentRequestDtoFromJSON,
    IProcessEnrollmentRequestDtoToJSON,
    IProcessingRuleDtoFromJSON,
    IProcessingRuleDtoToJSON,
    IProviderInfoDtoFromJSON,
    IProviderInfoDtoToJSON,
    IQrCodeOverridablePropertiesDtoFromJSON,
    IQrCodeOverridablePropertiesDtoToJSON,
    IRecurringContributionAggregateResponseDtoFromJSON,
    IRecurringContributionAggregateResponseDtoToJSON,
    IRecurringContributionAggregatorRequestDtoFromJSON,
    IRecurringContributionAggregatorRequestDtoToJSON,
    IRecurringContributionPatchUpdateRequestDtoFromJSON,
    IRecurringContributionPatchUpdateRequestDtoToJSON,
    IRecurringContributionResponseDtoFromJSON,
    IRecurringContributionResponseDtoToJSON,
    IRelatedClaimEnhancedDtoFromJSON,
    IRelatedClaimEnhancedDtoToJSON,
    IRenewalRecordDtoFromJSON,
    IRenewalRecordDtoToJSON,
    IRenewalRecordExtendedDtoFromJSON,
    IRenewalRecordExtendedDtoToJSON,
    IRetryClaimPaymentDtoFromJSON,
    IRetryClaimPaymentDtoToJSON,
    ISequenceDtoFromJSON,
    ISequenceDtoToJSON,
    ISignUpRequestDtoFromJSON,
    ISignUpRequestDtoToJSON,
    ITradeCreateDtoFromJSON,
    ITradeCreateDtoToJSON,
    IUpdateLockboxAggregatorDtoFromJSON,
    IUpdateLockboxAggregatorDtoToJSON,
    IUpdatePaymentMethodRequestDtoFromJSON,
    IUpdatePaymentMethodRequestDtoToJSON,
} from '../models/index';

export interface AcceptEmployeeContributionRequest {
    iEeContributionRequestDto?: IEeContributionRequestDto;
}

export interface AccountActivitiesRequest {
    accountId: string;
}

export interface AccountActivitiesPageableRequest {
    accountId: string;
    page: string;
    size: string;
    periodFrom?: string;
    periodTo?: string;
    transactionTypes?: string;
    memo?: string;
    sort?: string;
}

export interface AccountOrdersRequest {
    employeeId?: string;
    serviceId?: string;
    serviceOn?: string;
    claimValue?: string;
    dependentId?: string;
}

export interface AccountOrdersServicesRequest {
    employeeId?: string;
    dependentId?: string;
    serviceOn?: string;
}

export interface CardPursesRequest {
    employeeId: string;
}

export interface ChangeClaimDocumentRequest {
    claimId: string;
    iDocumentIdDto?: IDocumentIdDto;
}

export interface ChangeClaimDocumentByLinkRequest {
    claimId: string;
    hashId: string;
}

export interface CipIdologyIdentificationRequest {
    employeeId?: string;
}

export interface ClaimsSearchRequest {
    pageSize: string;
    page: string;
    categoryType?: string;
    claimStatus?: string;
    periodFrom?: string;
    periodTo?: string;
    searchValue?: string;
    externalIdentifier?: string;
    paymentType?: string;
    onlyMyAssignments?: string;
    field?: string;
    direct?: string;
    showOnlyEscalated?: string;
    isAppealed?: string;
    isAppealProcessed?: string;
}

export interface CreateAutoInvestmentSchedulerRequest {
    iAutoInvestmentSchedulerRequestDto?: IAutoInvestmentSchedulerRequestDto;
}

export interface CreateCarrierConfigRequest {
    iCreateCarrierConfigAggregatorDto?: ICreateCarrierConfigAggregatorDto;
}

export interface CreateClaimRequest {
    iCreateClaimAggregatorDto?: ICreateClaimAggregatorDto;
}

export interface CreateCoverageRequest {
    iCoverageDto?: ICoverageDto;
}

export interface CreateDebitCardPaymentMethodRequest {
    iCreateDebitCardRequest?: ICreateDebitCardRequest;
}

export interface CreateDependentRequest {
    updateCardHolder?: string;
    iDependentInfoDto?: IDependentInfoDto;
}

export interface CreateDependent1Request {
    updateCardHolder?: string;
    iDependentRequestDto?: IDependentRequestDto;
}

export interface CreateDocumentRequest {
    iCreateDocumentAggregatorDto?: ICreateDocumentAggregatorDto;
}

export interface CreateEmployeeRequest {
    iEmployeeInfoCreateAggregatorDto?: IEmployeeInfoCreateAggregatorDto;
}

export interface CreateEmployerTerminationPropertiesRequest {
    organizationId: string;
    iEmployerTerminationPropertiesCreateDto?: IEmployerTerminationPropertiesCreateDto;
}

export interface CreateEmployerTerminationProperties2Request {
    organizationId: string;
    iEmployerTerminationPropertiesV3Dto?: IEmployerTerminationPropertiesV3Dto;
}

export interface CreateExpressSetupRequest {
    iOrganizationInfoDto?: IOrganizationInfoDto;
}

export interface CreateNewPaymentAccountRequest {
    iPaymentAccountRequestDto?: IPaymentAccountRequestDto;
}

export interface CreateOrUpdateRecurringContributionRequest {
    accountId: string;
    personId: string;
    iRecurringContributionAggregatorRequestDto?: IRecurringContributionAggregatorRequestDto;
}

export interface CreateProcessingRuleRequest {
    iProcessingRuleDto?: IProcessingRuleDto;
}

export interface CreateProviderRequest {
    iCreateProviderAggregatorDto?: ICreateProviderAggregatorDto;
}

export interface EnrollmentMatrixCreationRequest {
    iEnrollmentMatrixDto?: IEnrollmentMatrixDto;
}

export interface GetActivePayrollCalendarByIdRequest {
    id: string;
}

export interface GetActivePayrollCalendarsByOrgIdRequest {
    organizationId: string;
}

export interface GetAllMonitorContributionInfoRequest {
    accountId: string;
    personId: string;
    taxYear: string;
    employeeId?: string;
}

export interface GetAllRecurringContributionInfoRequest {
    accountId: string;
    personId: string;
    taxYear: string;
}

export interface GetCarrierConfigDetailsRequest {
    searchValue?: string;
    purposeTypes?: string;
    statusType?: string;
    page?: string;
    size?: string;
    sort?: string;
}

export interface GetClaimActivityDetailsRequest {
    claimId: string;
}

export interface GetClaimByIdRequest {
    claimId: string;
}

export interface GetClaimPaymentDetailsRequest {
    claimId: string;
}

export interface GetClaimRelatedCardSwipesRequest {
    claimId: string;
    page?: string;
    size?: string;
    sort?: string;
}

export interface GetEmployeesIrsLimitsRequest {
    taxYear: string;
    employeePlanPairs: string;
    size: string;
    page: string;
    sort?: string;
}

export interface GetEnrollmentsRequest {
    employeeId?: string;
    planId?: string;
    accountId?: string;
    accountStatus?: GetEnrollmentsAccountStatusEnum;
    status?: GetEnrollmentsStatusEnum;
}

export interface GetErrorsRequest {
    fileId: string;
    page?: string;
    size?: string;
    sort?: string;
}

export interface GetErrorsCsvRequest {
    fileId: string;
}

export interface GetExpressSetupRequest {
    organizationId: string;
}

export interface GetFileDetailsByIdRequest {
    fileId: string;
}

export interface GetInvestmentHoldingsRequest {
    accountId?: string;
}

export interface GetInvoiceDetailsByIdRequest {
    invoiceId: string;
}

export interface GetLockboxDetailsRequest {
    lockboxId: string;
}

export interface GetLockboxEmployeeDetailsRequest {
    employeeId: string;
}

export interface GetMobileAppLinkByOneTimeLinkRequest {
    hashId: string;
}

export interface GetMobileAppLinkByQrCodeRequest {
    qrId: string;
}

export interface GetNotificationTemplateVariablesRequest {
    id: string;
    organizationId?: string;
}

export interface GetPageableOrganizationsRequest {
    organizationIds?: string;
    partnerId?: string;
    parentId?: string;
    parentIds?: string;
    type?: GetPageableOrganizationsTypeEnum;
    statuses?: GetPageableOrganizationsStatusesEnum;
    searchValue?: string;
    page?: string;
    size?: string;
    sort?: Array<string>;
}

export interface GetPlanRenewalsRequest {
    planYearId: string;
}

export interface GetPostingActivityDetailsRequest {
    postingId: string;
}

export interface GetPrefundSummaryByInvoiceIdRequest {
    invoiceId: string;
}

export interface GetRejectedClaimInfoRequest {
    claimId: string;
}

export interface GetRenewalsRequest {
    organizationId: string;
}

export interface GetRepaymentMatchesClaimsInfoRequest {
    searchValue: string;
    page?: string;
    size?: string;
}

export interface HealthPlanCreationRequest {
    iHealthPlanCreateDto?: IHealthPlanCreateDto;
}

export interface HealthPlanUpdateRequest {
    healthPlanId: string;
    iHealthPlanUpdateDto?: IHealthPlanUpdateDto;
}

export interface InvoiceDashboardRequest {
    searchValue?: string;
    invoiceTypes?: IInvoiceType;
    achMethods?: InvoiceDashboardAchMethodsEnum;
    endedFrom?: string;
    endedTo?: string;
    invoiceStatusTypes?: string;
    size?: string;
    page?: string;
    sort?: string;
}

export interface MatchEmployeesRequest {
    searchValue?: string;
}

export interface MatchEmployees1Request {
    employeeId: string;
}

export interface OpenaiOcrReaderRequest {
    fileId: string;
    hashId: string;
}

export interface OpenaiOcrReader1Request {
    fileId: string;
}

export interface OpenaiOcrReader2Request {
    fileId: string;
    claimId: string;
}

export interface OrganizationLockRequest {
    organizationId: string;
}

export interface OrganizationUnlockRequest {
    organizationId: string;
}

export interface PatchLinkedSystemTemplatesRequest {
    organizationId: string;
    iPatchLinkedSystemTemplatesDto?: IPatchLinkedSystemTemplatesDto;
}

export interface PatchPlanRenewalsRequest {
    planYearId: string;
}

export interface PaymentMethodSetupRequest {
    employeeId?: string;
    iPaymentMethodSetupRequestDto?: IPaymentMethodSetupRequestDto;
}

export interface PaymentMethodsGetRequest {
    employeeId?: string;
    paymentMethodType?: string;
    page?: string;
    size?: string;
    sort?: Array<string>;
}

export interface PlanCreationRequest {
    iPlanDto?: IPlanDto;
}

export interface PlanDeleteRequest {
    planId: string;
}

export interface PlanTerminationPropertiesDeleteRequest {
    planId: string;
}

export interface PlanUpdateRequest {
    planId: string;
    iPlanDto?: IPlanDto;
}

export interface PlanYearRequest {
    planYearId: string;
    iPlanYearDto?: IPlanYearDto;
}

export interface PlanYearCreationRequest {
    iPlanYearDto?: IPlanYearDto;
}

export interface ProcessEnrollmentRequest {
    iProcessEnrollmentRequestDto?: IProcessEnrollmentRequestDto;
}

export interface ProcessHealthPlanEnrollmentRequest {
    iProcessEnrollmentRequestDto?: IProcessEnrollmentRequestDto;
}

export interface ReissueCheckByIdRequest {
    checkId: string;
    iCheckReissueDto: ICheckReissueDto;
}

export interface RetryClaimPaymentRequest {
    iRetryClaimPaymentDto?: IRetryClaimPaymentDto;
}

export interface SearchChecksRequest {
    size: string;
    page: string;
    searchValue?: string;
    issuedDateFrom?: string;
    issuedDateTo?: string;
    checkStatusTypes?: SearchChecksCheckStatusTypesEnum;
    organizationId?: string;
    sort?: string;
}

export interface SearchContributionsRequest {
    submitDateFrom?: string;
    submitDateTo?: string;
    planCodes?: string;
    contributionSource?: SearchContributionsContributionSourceEnum;
    page?: string;
    size?: string;
}

export interface SearchFileActorsRequest {
    searchValue?: string;
}

export interface SearchFilesRequest {
    page: string;
    size: string;
    searchValue?: string;
    uploadedBy?: string;
    fileType?: string;
    fileProcessingStatusType?: string;
    createdDateFrom?: string;
    createdDateTo?: string;
    duplicateFileId?: string;
    sort?: string;
}

export interface SelectingInvestmentFundingRequest {
    iFundingPatchDto?: IFundingPatchDto;
}

export interface SelectingInvestmentPathRequest {
    termsAccepted: boolean;
    iInvestmentOperationRequestDto?: IInvestmentOperationRequestDto;
}

export interface SequenceCreationRequest {
    iSequenceDto?: ISequenceDto;
}

export interface SignUpRequest {
    iSignUpRequestDto?: ISignUpRequestDto;
}

export interface StartClaimRepaymentRequest {
    claimId: string;
    iClaimRepaymentStartDto?: IClaimRepaymentStartDto;
}

export interface StartInvestmentsRequest {
    accountId?: string;
}

export interface SubmitHideBadDataRequest {
    employeeId: string;
    iEmployeeBadRecordRequestDto?: IEmployeeBadRecordRequestDto;
}

export interface SubmitManualContributionRequest {
    iAggregatorManualContributionRequestDto?: IAggregatorManualContributionRequestDto;
}

export interface SwitchInvestmentModelRequest {
    iInvestmentModelSwitchDto?: IInvestmentModelSwitchDto;
}

export interface TradesRequest {
    iTradeCreateDto?: ITradeCreateDto;
}

export interface TransferAccountsByEmployeeRequest {
    employeeId: string;
}

export interface TransferClaimRequest {
    claimId: string;
    iClaimTransferCreateBatchDto?: IClaimTransferCreateBatchDto;
}

export interface UnlinkTemplatesRequest {
    planId: string;
    organizationId?: string;
}

export interface UpdateAutoInvestmentSchedulerRequest {
    iAutoInvestmentSchedulerUpdateDto?: IAutoInvestmentSchedulerUpdateDto;
}

export interface UpdateDependentRequest {
    dependentId: string;
    updateCardHolder?: string;
    iDependentInfoDto?: IDependentInfoDto;
}

export interface UpdateDependent1Request {
    dependentId: string;
    updateCardHolder?: string;
    iDependentUpdateDto?: IDependentUpdateDto;
}

export interface UpdateEmployeeRequest {
    employeeId: string;
    iEmployeeInfoUpdateDto?: IEmployeeInfoUpdateDto;
}

export interface UpdateEmployerTerminationProperties1Request {
    organizationId: string;
    iEmployerTerminationPropertiesV3Dto?: IEmployerTerminationPropertiesV3Dto;
}

export interface UpdateExpressSetupRequest {
    organizationId: string;
    iExpressSetupDto?: IExpressSetupDto;
}

export interface UpdateExpressSetupStatusRequest {
    organizationId: string;
    status: UpdateExpressSetupStatusStatusEnum;
}

export interface UpdateLockboxRequest {
    lockboxId: string;
    iUpdateLockboxAggregatorDto?: IUpdateLockboxAggregatorDto;
}

export interface UpdatePaymentMethodRequest {
    id: string;
    fiservAccessToken?: string;
    iUpdatePaymentMethodRequestDto?: IUpdatePaymentMethodRequestDto;
}

export interface UpdateStatusRecurringContributionRequest {
    id: string;
    iRecurringContributionPatchUpdateRequestDto?: IRecurringContributionPatchUpdateRequestDto;
}

export interface VerifyUserCardRequest {
    last4?: string;
}

export interface VoidCheckByIdRequest {
    checkId: string;
    iCheckVoidDto: ICheckVoidDto;
}

export interface WireCardToRecipientRequest {
    id: string;
    fiservAccessToken?: string;
    iFiservCardVaultToken?: IFiservCardVaultToken;
}

/**
 * ApiAggregatorServiceApi - interface
 * 
 * @export
 * @interface ApiAggregatorServiceApiInterface
 */
export interface ApiAggregatorServiceApiInterface {
    /**
     * 
     * @summary create employee contribution
     * @param {IEeContributionRequestDto} [iEeContributionRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    acceptEmployeeContributionRaw(requestParameters: AcceptEmployeeContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEeContributionResponseDto>>;

    /**
     * create employee contribution
     */
    acceptEmployeeContribution(requestParameters: AcceptEmployeeContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEeContributionResponseDto>;

    /**
     * 
     * @summary Search account activities
     * @param {string} accountId Account Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    accountActivitiesRaw(requestParameters: AccountActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedAccountActivityDto>>>;

    /**
     * Search account activities
     */
    accountActivities(requestParameters: AccountActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedAccountActivityDto>>;

    /**
     * 
     * @summary Search account activities pageable
     * @param {string} accountId Account Id
     * @param {string} page 
     * @param {string} size 
     * @param {string} [periodFrom] Period From
     * @param {string} [periodTo] Period To
     * @param {string} [transactionTypes] Transaction Types
     * @param {string} [memo] Memo Like
     * @param {string} [sort] Sort criteria field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    accountActivitiesPageableRaw(requestParameters: AccountActivitiesPageableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedAccountActivityDto>>>;

    /**
     * Search account activities pageable
     */
    accountActivitiesPageable(requestParameters: AccountActivitiesPageableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedAccountActivityDto>>;

    /**
     * 
     * @summary Get account orders
     * @param {string} [employeeId] Employee Id
     * @param {string} [serviceId] Service Id
     * @param {string} [serviceOn] Service on date
     * @param {string} [claimValue] Claim value amount
     * @param {string} [dependentId] Dependent Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    accountOrdersRaw(requestParameters: AccountOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountOrderDto>>;

    /**
     * Get account orders
     */
    accountOrders(requestParameters: AccountOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountOrderDto>;

    /**
     * 
     * @summary Get account orders services
     * @param {string} [employeeId] Employee Id
     * @param {string} [dependentId] Dependent Id
     * @param {string} [serviceOn] Service on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    accountOrdersServicesRaw(requestParameters: AccountOrdersServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountOrderMatrixDto>>;

    /**
     * Get account orders services
     */
    accountOrdersServices(requestParameters: AccountOrdersServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountOrderMatrixDto>;

    /**
     * 
     * @summary Get card purses by employee id
     * @param {string} employeeId Employee id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    cardPursesRaw(requestParameters: CardPursesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICardPurseDto>>>;

    /**
     * Get card purses by employee id
     */
    cardPurses(requestParameters: CardPursesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICardPurseDto>>;

    /**
     * 
     * @summary Change Claim Document
     * @param {string} claimId Claim ID
     * @param {IDocumentIdDto} [iDocumentIdDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    changeClaimDocumentRaw(requestParameters: ChangeClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>>;

    /**
     * Change Claim Document
     */
    changeClaimDocument(requestParameters: ChangeClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto>;

    /**
     * 
     * @summary Change Claim Document by Link
     * @param {string} claimId Claim ID
     * @param {string} hashId Hash ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    changeClaimDocumentByLinkRaw(requestParameters: ChangeClaimDocumentByLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrivateClaimInfoResponseDto>>;

    /**
     * Change Claim Document by Link
     */
    changeClaimDocumentByLink(requestParameters: ChangeClaimDocumentByLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrivateClaimInfoResponseDto>;

    /**
     * 
     * @summary CIP identity verification
     * @param {string} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    cipIdologyIdentificationRaw(requestParameters: CipIdologyIdentificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>>;

    /**
     * CIP identity verification
     */
    cipIdologyIdentification(requestParameters: CipIdologyIdentificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto>;

    /**
     * 
     * @summary Claims Search
     * @param {string} pageSize 
     * @param {string} page 
     * @param {string} [categoryType] 
     * @param {string} [claimStatus] 
     * @param {string} [periodFrom] 
     * @param {string} [periodTo] 
     * @param {string} [searchValue] 
     * @param {string} [externalIdentifier] 
     * @param {string} [paymentType] 
     * @param {string} [onlyMyAssignments] 
     * @param {string} [field] List of sort criteria field
     * @param {string} [direct] List of sort criteria direct
     * @param {string} [showOnlyEscalated] 
     * @param {string} [isAppealed] 
     * @param {string} [isAppealProcessed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    claimsSearchRaw(requestParameters: ClaimsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsResponseAggregatorDtoPage>>;

    /**
     * Claims Search
     */
    claimsSearch(requestParameters: ClaimsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsResponseAggregatorDtoPage>;

    /**
     * 
     * @summary Create auto-investment scheduler
     * @param {IAutoInvestmentSchedulerRequestDto} [iAutoInvestmentSchedulerRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createAutoInvestmentSchedulerRaw(requestParameters: CreateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>>;

    /**
     * Create auto-investment scheduler
     */
    createAutoInvestmentScheduler(requestParameters: CreateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto>;

    /**
     * 
     * @summary Create Carrier config
     * @param {ICreateCarrierConfigAggregatorDto} [iCreateCarrierConfigAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createCarrierConfigRaw(requestParameters: CreateCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigResponseAggregatorDto>>;

    /**
     * Create Carrier config
     */
    createCarrierConfig(requestParameters: CreateCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigResponseAggregatorDto>;

    /**
     * 
     * @summary Create Claim
     * @param {ICreateClaimAggregatorDto} [iCreateClaimAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createClaimRaw(requestParameters: CreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>>;

    /**
     * Create Claim
     */
    createClaim(requestParameters: CreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto>;

    /**
     * 
     * @summary Create coverage
     * @param {ICoverageDto} [iCoverageDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createCoverageRaw(requestParameters: CreateCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICoverageDto>>;

    /**
     * Create coverage
     */
    createCoverage(requestParameters: CreateCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICoverageDto>;

    /**
     * 
     * @summary Create debit card payment method
     * @param {ICreateDebitCardRequest} [iCreateDebitCardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createDebitCardPaymentMethodRaw(requestParameters: CreateDebitCardPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>>;

    /**
     * Create debit card payment method
     */
    createDebitCardPaymentMethod(requestParameters: CreateDebitCardPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto>;

    /**
     * 
     * @summary Create Dependent
     * @param {string} [updateCardHolder] Update card holder
     * @param {IDependentInfoDto} [iDependentInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createDependentRaw(requestParameters: CreateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>>;

    /**
     * Create Dependent
     */
    createDependent(requestParameters: CreateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto>;

    /**
     * 
     * @summary Create Dependent
     * @param {string} [updateCardHolder] Update card holder
     * @param {IDependentRequestDto} [iDependentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createDependent1Raw(requestParameters: CreateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>>;

    /**
     * Create Dependent
     */
    createDependent1(requestParameters: CreateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto>;

    /**
     * 
     * @summary Create document
     * @param {ICreateDocumentAggregatorDto} [iCreateDocumentAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createDocumentRaw(requestParameters: CreateDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>>;

    /**
     * Create document
     */
    createDocument(requestParameters: CreateDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto>;

    /**
     * 
     * @summary Create Employee
     * @param {IEmployeeInfoCreateAggregatorDto} [iEmployeeInfoCreateAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createEmployeeRaw(requestParameters: CreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>>;

    /**
     * Create Employee
     */
    createEmployee(requestParameters: CreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto>;

    /**
     * 
     * @summary Create employer termination properties for organization
     * @param {string} organizationId Organization ID
     * @param {IEmployerTerminationPropertiesCreateDto} [iEmployerTerminationPropertiesCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createEmployerTerminationPropertiesRaw(requestParameters: CreateEmployerTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>>;

    /**
     * Create employer termination properties for organization
     */
    createEmployerTerminationProperties(requestParameters: CreateEmployerTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto>;

    /**
     * 
     * @summary Create employer termination properties for organization
     * @param {string} organizationId Organization ID
     * @param {IEmployerTerminationPropertiesV3Dto} [iEmployerTerminationPropertiesV3Dto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createEmployerTerminationProperties2Raw(requestParameters: CreateEmployerTerminationProperties2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>>;

    /**
     * Create employer termination properties for organization
     */
    createEmployerTerminationProperties2(requestParameters: CreateEmployerTerminationProperties2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto>;

    /**
     * 
     * @summary Create new express setup together with organization
     * @param {IOrganizationInfoDto} [iOrganizationInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createExpressSetupRaw(requestParameters: CreateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>>;

    /**
     * Create new express setup together with organization
     */
    createExpressSetup(requestParameters: CreateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto>;

    /**
     * 
     * @summary Create new payment account
     * @param {IPaymentAccountRequestDto} [iPaymentAccountRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createNewPaymentAccountRaw(requestParameters: CreateNewPaymentAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentAccountResponseDto>>;

    /**
     * Create new payment account
     */
    createNewPaymentAccount(requestParameters: CreateNewPaymentAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentAccountResponseDto>;

    /**
     * 
     * @summary Create Recurring Contribution or Update recurring contribution by employeeId
     * @param {string} accountId 
     * @param {string} personId 
     * @param {IRecurringContributionAggregatorRequestDto} [iRecurringContributionAggregatorRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createOrUpdateRecurringContributionRaw(requestParameters: CreateOrUpdateRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionAggregateResponseDto>>;

    /**
     * Create Recurring Contribution or Update recurring contribution by employeeId
     */
    createOrUpdateRecurringContribution(requestParameters: CreateOrUpdateRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionAggregateResponseDto | null | undefined >;

    /**
     * 
     * @summary Create processing rule
     * @param {IProcessingRuleDto} [iProcessingRuleDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createProcessingRuleRaw(requestParameters: CreateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>>;

    /**
     * Create processing rule
     */
    createProcessingRule(requestParameters: CreateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto>;

    /**
     * 
     * @summary Create provider
     * @param {ICreateProviderAggregatorDto} [iCreateProviderAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    createProviderRaw(requestParameters: CreateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>>;

    /**
     * Create provider
     */
    createProvider(requestParameters: CreateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto>;

    /**
     * 
     * @summary Create enrollment matrix and propagate org path
     * @param {IEnrollmentMatrixDto} [iEnrollmentMatrixDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    enrollmentMatrixCreationRaw(requestParameters: EnrollmentMatrixCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>>;

    /**
     * Create enrollment matrix and propagate org path
     */
    enrollmentMatrixCreation(requestParameters: EnrollmentMatrixCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto>;

    /**
     * 
     * @summary Get active payroll calendar by id
     * @param {string} id Payroll Calendar Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getActivePayrollCalendarByIdRaw(requestParameters: GetActivePayrollCalendarByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedAggregatorResponseDto>>;

    /**
     * Get active payroll calendar by id
     */
    getActivePayrollCalendarById(requestParameters: GetActivePayrollCalendarByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedAggregatorResponseDto>;

    /**
     * 
     * @summary Get active payroll calendars by org id
     * @param {string} organizationId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getActivePayrollCalendarsByOrgIdRaw(requestParameters: GetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarAggregatorResponseDto>>>;

    /**
     * Get active payroll calendars by org id
     */
    getActivePayrollCalendarsByOrgId(requestParameters: GetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarAggregatorResponseDto>>;

    /**
     * 
     * @summary Collect all monitor contribution info
     * @param {string} accountId 
     * @param {string} personId 
     * @param {string} taxYear 
     * @param {string} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getAllMonitorContributionInfoRaw(requestParameters: GetAllMonitorContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMonitorContributionAggregateResponseDto>>;

    /**
     * Collect all monitor contribution info
     */
    getAllMonitorContributionInfo(requestParameters: GetAllMonitorContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMonitorContributionAggregateResponseDto>;

    /**
     * 
     * @summary Collect and get all ACTIVE or PAUSED recurring contribution info
     * @param {string} accountId 
     * @param {string} personId 
     * @param {string} taxYear 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getAllRecurringContributionInfoRaw(requestParameters: GetAllRecurringContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionAggregateResponseDto>>;

    /**
     * Collect and get all ACTIVE or PAUSED recurring contribution info
     */
    getAllRecurringContributionInfo(requestParameters: GetAllRecurringContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionAggregateResponseDto>;

    /**
     * 
     * @summary Get balance reminder banner info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getBalanceReminderBannerInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceReminderResponseDto>>;

    /**
     * Get balance reminder banner info
     */
    getBalanceReminderBannerInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceReminderResponseDto>;

    /**
     * 
     * @summary Get Carrier config with organization name
     * @param {string} [searchValue] 
     * @param {string} [purposeTypes] 
     * @param {string} [statusType] 
     * @param {string} [page] 
     * @param {string} [size] 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getCarrierConfigDetailsRaw(requestParameters: GetCarrierConfigDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigResponseAggregatorDtoPage>>;

    /**
     * Get Carrier config with organization name
     */
    getCarrierConfigDetails(requestParameters: GetCarrierConfigDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigResponseAggregatorDtoPage | null | undefined >;

    /**
     * 
     * @summary Get claim based activity details
     * @param {string} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getClaimActivityDetailsRaw(requestParameters: GetClaimActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivityDetails>>;

    /**
     * Get claim based activity details
     */
    getClaimActivityDetails(requestParameters: GetClaimActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivityDetails>;

    /**
     * 
     * @summary Get claim by id
     * @param {string} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getClaimByIdRaw(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoAggregatorResponseDto>>;

    /**
     * Get claim by id
     */
    getClaimById(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoAggregatorResponseDto>;

    /**
     * 
     * @summary Claim Payment Details
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getClaimPaymentDetailsRaw(requestParameters: GetClaimPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentDetailsResponseDto>>;

    /**
     * Claim Payment Details
     */
    getClaimPaymentDetails(requestParameters: GetClaimPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentDetailsResponseDto | null | undefined >;

    /**
     * 
     * @summary Get claim related card swipes
     * @param {string} claimId Claim ID
     * @param {string} [page] 
     * @param {string} [size] 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getClaimRelatedCardSwipesRaw(requestParameters: GetClaimRelatedCardSwipesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IRelatedClaimEnhancedDto>>>;

    /**
     * Get claim related card swipes
     */
    getClaimRelatedCardSwipes(requestParameters: GetClaimRelatedCardSwipesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IRelatedClaimEnhancedDto>>;

    /**
     * 
     * @summary Get irs limits for contribution by employeesId and planId
     * @param {string} taxYear 
     * @param {string} employeePlanPairs Repeatable parameter for employee_id-plan_id pairs. Example: 1-10,2-20
     * @param {string} size 
     * @param {string} page 
     * @param {string} [sort] Sort criteria field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getEmployeesIrsLimitsRaw(requestParameters: GetEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeContributionLimitResponse>>>;

    /**
     * Get irs limits for contribution by employeesId and planId
     */
    getEmployeesIrsLimits(requestParameters: GetEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeContributionLimitResponse>>;

    /**
     * 
     * @summary Get enrollments ordered by plan\'s accountType,asc, validFrom,desc
     * @param {string} [employeeId] 
     * @param {string} [planId] 
     * @param {string} [accountId] 
     * @param {'OPEN' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'PENDING'} [accountStatus] 
     * @param {'ACTIVE' | 'CANCELED' | 'FUTURE' | 'EXPIRED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getEnrollmentsRaw(requestParameters: GetEnrollmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnrollmentDto>>>;

    /**
     * Get enrollments ordered by plan\'s accountType,asc, validFrom,desc
     */
    getEnrollments(requestParameters: GetEnrollmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnrollmentDto>>;

    /**
     * 
     * @summary Get file errors
     * @param {string} fileId File ID
     * @param {string} [page] Page number
     * @param {string} [size] Page size
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getErrorsRaw(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileRecordErrorAggregatorDto>>;

    /**
     * Get file errors
     */
    getErrors(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileRecordErrorAggregatorDto>;

    /**
     * 
     * @summary Get file errors in CSV format
     * @param {string} fileId File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getErrorsCsvRaw(requestParameters: GetErrorsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get file errors in CSV format
     */
    getErrorsCsv(requestParameters: GetErrorsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get express setup JSON record
     * @param {string} organizationId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getExpressSetupRaw(requestParameters: GetExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupExtendedDto>>;

    /**
     * Get express setup JSON record
     */
    getExpressSetup(requestParameters: GetExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupExtendedDto>;

    /**
     * 
     * @summary Get file details by id
     * @param {string} fileId File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getFileDetailsByIdRaw(requestParameters: GetFileDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileDetailsAggregatorResponseDto>>;

    /**
     * Get file details by id
     */
    getFileDetailsById(requestParameters: GetFileDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileDetailsAggregatorResponseDto>;

    /**
     * 
     * @summary Retrieve investments holdings.
     * @param {string} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getInvestmentHoldingsRaw(requestParameters: GetInvestmentHoldingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestmentHoldingsDto>>;

    /**
     * Retrieve investments holdings.
     */
    getInvestmentHoldings(requestParameters: GetInvestmentHoldingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestmentHoldingsDto>;

    /**
     * 
     * @summary Get invoices details by invoice id
     * @param {string} invoiceId Invoice id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getInvoiceDetailsByIdRaw(requestParameters: GetInvoiceDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceDetailsAggregatorDto>>;

    /**
     * Get invoices details by invoice id
     */
    getInvoiceDetailsById(requestParameters: GetInvoiceDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceDetailsAggregatorDto>;

    /**
     * 
     * @summary Retrieve lockbox details by id
     * @param {string} lockboxId Lockbox ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getLockboxDetailsRaw(requestParameters: GetLockboxDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDetailsAggregatorDto>>;

    /**
     * Retrieve lockbox details by id
     */
    getLockboxDetails(requestParameters: GetLockboxDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDetailsAggregatorDto>;

    /**
     * 
     * @summary Retrieve lockbox employee details by employee id
     * @param {string} employeeId Employee ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getLockboxEmployeeDetailsRaw(requestParameters: GetLockboxEmployeeDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDetailsAggregatorDto>>;

    /**
     * Retrieve lockbox employee details by employee id
     */
    getLockboxEmployeeDetails(requestParameters: GetLockboxEmployeeDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDetailsAggregatorDto>;

    /**
     * 
     * @summary Get mobile app link from organization by one time link
     * @param {string} hashId Hash ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getMobileAppLinkByOneTimeLinkRaw(requestParameters: GetMobileAppLinkByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeOverridablePropertiesDto>>;

    /**
     * Get mobile app link from organization by one time link
     */
    getMobileAppLinkByOneTimeLink(requestParameters: GetMobileAppLinkByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeOverridablePropertiesDto>;

    /**
     * 
     * @summary Get mobile app link from organization by qr code
     * @param {string} qrId Qr ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getMobileAppLinkByQrCodeRaw(requestParameters: GetMobileAppLinkByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeOverridablePropertiesDto>>;

    /**
     * Get mobile app link from organization by qr code
     */
    getMobileAppLinkByQrCode(requestParameters: GetMobileAppLinkByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeOverridablePropertiesDto>;

    /**
     * 
     * @summary Get notification template variables
     * @param {string} id External template ID
     * @param {string} [organizationId] Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getNotificationTemplateVariablesRaw(requestParameters: GetNotificationTemplateVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get notification template variables
     */
    getNotificationTemplateVariables(requestParameters: GetNotificationTemplateVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get pageable organizations
     * @param {string} [organizationIds] 
     * @param {string} [partnerId] 
     * @param {string} [parentId] 
     * @param {string} [parentIds] 
     * @param {'SYSTEM' | 'PARTNER' | 'DISTRIBUTOR' | 'COMPANY' | 'SUBSIDIARY' | 'SUBGROUP'} [type] 
     * @param {'PENDING' | 'ACTIVE' | 'TERMINATED' | 'ACTIVATION_FAILED' | 'PENDING_TERMINATION' | 'EXPRESS_SETUP' | 'ABANDONED' | 'TERMINATION_IN_PROGRESS' | 'PENDING_REACTIVATION'} [statuses] 
     * @param {string} [searchValue] 
     * @param {string} [page] 
     * @param {string} [size] 
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getPageableOrganizationsRaw(requestParameters: GetPageableOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationExpressSetupResponseDto>>;

    /**
     * Get pageable organizations
     */
    getPageableOrganizations(requestParameters: GetPageableOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationExpressSetupResponseDto>;

    /**
     * 
     * @summary Get plan renewals
     * @param {string} planYearId Plan year Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getPlanRenewalsRaw(requestParameters: GetPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRenewalRecordExtendedDto>>;

    /**
     * Get plan renewals
     */
    getPlanRenewals(requestParameters: GetPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRenewalRecordExtendedDto>;

    /**
     * 
     * @summary Get posting based activity details
     * @param {string} postingId Posting ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getPostingActivityDetailsRaw(requestParameters: GetPostingActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBankingActivityDetails>>;

    /**
     * Get posting based activity details
     */
    getPostingActivityDetails(requestParameters: GetPostingActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBankingActivityDetails>;

    /**
     * 
     * @summary Collect prefund summary by invoice id
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getPrefundSummaryByInvoiceIdRaw(requestParameters: GetPrefundSummaryByInvoiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrefundSummaryDto>>;

    /**
     * Collect prefund summary by invoice id
     */
    getPrefundSummaryByInvoiceId(requestParameters: GetPrefundSummaryByInvoiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrefundSummaryDto>;

    /**
     * 
     * @summary Get rejected claim info by claim id
     * @param {string} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getRejectedClaimInfoRaw(requestParameters: GetRejectedClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimRejectedAggregatorDto>>;

    /**
     * Get rejected claim info by claim id
     */
    getRejectedClaimInfo(requestParameters: GetRejectedClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimRejectedAggregatorDto>;

    /**
     * 
     * @summary Get renewals
     * @param {string} organizationId Organization Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getRenewalsRaw(requestParameters: GetRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IRenewalRecordExtendedDto>>>;

    /**
     * Get renewals
     */
    getRenewals(requestParameters: GetRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IRenewalRecordExtendedDto>>;

    /**
     * 
     * @summary Get repayment claims info
     * @param {string} searchValue 
     * @param {string} [page] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    getRepaymentMatchesClaimsInfoRaw(requestParameters: GetRepaymentMatchesClaimsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimRepaymentAggregatedDto>>;

    /**
     * Get repayment claims info
     */
    getRepaymentMatchesClaimsInfo(requestParameters: GetRepaymentMatchesClaimsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimRepaymentAggregatedDto>;

    /**
     * 
     * @summary Create health plan and propagate orgId
     * @param {IHealthPlanCreateDto} [iHealthPlanCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    healthPlanCreationRaw(requestParameters: HealthPlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanDto>>;

    /**
     * Create health plan and propagate orgId
     */
    healthPlanCreation(requestParameters: HealthPlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanDto>;

    /**
     * 
     * @summary Update health plan
     * @param {string} healthPlanId 
     * @param {IHealthPlanUpdateDto} [iHealthPlanUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    healthPlanUpdateRaw(requestParameters: HealthPlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanDto>>;

    /**
     * Update health plan
     */
    healthPlanUpdate(requestParameters: HealthPlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanDto>;

    /**
     * 
     * @summary Search invoices for dashboard
     * @param {string} [searchValue] Value for search by organization name or invoice id
     * @param {IInvoiceType} [invoiceTypes] 
     * @param {'NONE' | 'PUSH' | 'PULL'} [achMethods] 
     * @param {string} [endedFrom] 
     * @param {string} [endedTo] 
     * @param {string} [invoiceStatusTypes] 
     * @param {string} [size] 
     * @param {string} [page] 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    invoiceDashboardRaw(requestParameters: InvoiceDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceDashboardPageDto>>;

    /**
     * Search invoices for dashboard
     */
    invoiceDashboard(requestParameters: InvoiceDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceDashboardPageDto>;

    /**
     * 
     * @summary Search for organization logo and enrollments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    linkedEmployeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedEmployeeLinkedAccountsDto>>>;

    /**
     * Search for organization logo and enrollments
     */
    linkedEmployees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedEmployeeLinkedAccountsDto>>;

    /**
     * 
     * @summary Match employees by search value
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    matchEmployeesRaw(requestParameters: MatchEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMatchDetailsAggregatorDto>>;

    /**
     * Match employees by search value
     */
    matchEmployees(requestParameters: MatchEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMatchDetailsAggregatorDto>;

    /**
     * 
     * @summary Retrieve extended employee info
     * @param {string} employeeId Employee ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    matchEmployees1Raw(requestParameters: MatchEmployees1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMatchDetailsAggregatorDto>>;

    /**
     * Retrieve extended employee info
     */
    matchEmployees1(requestParameters: MatchEmployees1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMatchDetailsAggregatorDto>;

    /**
     * 
     * @summary Open AI OCR Docs Needed file matching with provided details
     * @param {string} fileId File ID
     * @param {string} hashId Hash ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    openaiOcrReaderRaw(requestParameters: OpenaiOcrReaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>>;

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    openaiOcrReader(requestParameters: OpenaiOcrReaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto>;

    /**
     * 
     * @summary Openai ocr reader
     * @param {string} fileId File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    openaiOcrReader1Raw(requestParameters: OpenaiOcrReader1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>>;

    /**
     * Openai ocr reader
     */
    openaiOcrReader1(requestParameters: OpenaiOcrReader1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto>;

    /**
     * 
     * @summary Open AI OCR Docs Needed file matching with provided details
     * @param {string} fileId File ID
     * @param {string} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    openaiOcrReader2Raw(requestParameters: OpenaiOcrReader2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>>;

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    openaiOcrReader2(requestParameters: OpenaiOcrReader2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto>;

    /**
     * 
     * @summary Organization lock
     * @param {string} organizationId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    organizationLockRaw(requestParameters: OrganizationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>>;

    /**
     * Organization lock
     */
    organizationLock(requestParameters: OrganizationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto>;

    /**
     * 
     * @summary Organization unlock
     * @param {string} organizationId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    organizationUnlockRaw(requestParameters: OrganizationUnlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>>;

    /**
     * Organization unlock
     */
    organizationUnlock(requestParameters: OrganizationUnlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto>;

    /**
     * 
     * @summary Update system templates for organizations
     * @param {string} organizationId Partner ID
     * @param {IPatchLinkedSystemTemplatesDto} [iPatchLinkedSystemTemplatesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    patchLinkedSystemTemplatesRaw(requestParameters: PatchLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update system templates for organizations
     */
    patchLinkedSystemTemplates(requestParameters: PatchLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Patch plan renewal by plan year id
     * @param {string} planYearId Plan year Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    patchPlanRenewalsRaw(requestParameters: PatchPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRenewalRecordDto>>;

    /**
     * Patch plan renewal by plan year id
     */
    patchPlanRenewals(requestParameters: PatchPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRenewalRecordDto>;

    /**
     * 
     * @summary Payment Method Setup
     * @param {string} [employeeId] Required for Partner usage.
     * @param {IPaymentMethodSetupRequestDto} [iPaymentMethodSetupRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    paymentMethodSetupRaw(requestParameters: PaymentMethodSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>>;

    /**
     * Payment Method Setup
     */
    paymentMethodSetup(requestParameters: PaymentMethodSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto>;

    /**
     * 
     * @summary Get Payment Methods
     * @param {string} [employeeId] Employee id. Required for Partner usage.
     * @param {string} [paymentMethodType] Payment method type.
     * @param {string} [page] Zero-based page index (0..N)
     * @param {string} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    paymentMethodsGetRaw(requestParameters: PaymentMethodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPaymentMethodSetupResponseDto>>>;

    /**
     * Get Payment Methods
     */
    paymentMethodsGet(requestParameters: PaymentMethodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPaymentMethodSetupResponseDto>>;

    /**
     * 
     * @summary Create plan and propagate org id
     * @param {IPlanDto} [iPlanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planCreationRaw(requestParameters: PlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>>;

    /**
     * Create plan and propagate org id
     */
    planCreation(requestParameters: PlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto>;

    /**
     * 
     * @summary Delete plan/template by id
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planDeleteRaw(requestParameters: PlanDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete plan/template by id
     */
    planDelete(requestParameters: PlanDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete plan termination properties by plan id
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planTerminationPropertiesDeleteRaw(requestParameters: PlanTerminationPropertiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete plan termination properties by plan id
     */
    planTerminationPropertiesDelete(requestParameters: PlanTerminationPropertiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Updates plan by id
     * @param {string} planId 
     * @param {IPlanDto} [iPlanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planUpdateRaw(requestParameters: PlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>>;

    /**
     * Updates plan by id
     */
    planUpdate(requestParameters: PlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto>;

    /**
     * 
     * @summary Updates plan year by id
     * @param {string} planYearId 
     * @param {IPlanYearDto} [iPlanYearDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planYearRaw(requestParameters: PlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>>;

    /**
     * Updates plan year by id
     */
    planYear(requestParameters: PlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto>;

    /**
     * 
     * @summary Create plan year and propagate org id
     * @param {IPlanYearDto} [iPlanYearDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    planYearCreationRaw(requestParameters: PlanYearCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>>;

    /**
     * Create plan year and propagate org id
     */
    planYearCreation(requestParameters: PlanYearCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto>;

    /**
     * 
     * @summary Process single enrollment record
     * @param {IProcessEnrollmentRequestDto} [iProcessEnrollmentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    processEnrollmentRaw(requestParameters: ProcessEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentRecordDto>>;

    /**
     * Process single enrollment record
     */
    processEnrollment(requestParameters: ProcessEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentRecordDto>;

    /**
     * 
     * @summary Process single enrollment record for a health plan
     * @param {IProcessEnrollmentRequestDto} [iProcessEnrollmentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    processHealthPlanEnrollmentRaw(requestParameters: ProcessHealthPlanEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentRecordDto>>;

    /**
     * Process single enrollment record for a health plan
     */
    processHealthPlanEnrollment(requestParameters: ProcessHealthPlanEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentRecordDto>;

    /**
     * 
     * @summary Reissue check by id
     * @param {string} checkId 
     * @param {ICheckReissueDto} iCheckReissueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    reissueCheckByIdRaw(requestParameters: ReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reissue check by id
     */
    reissueCheckById(requestParameters: ReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary retry claim payment
     * @param {IRetryClaimPaymentDto} [iRetryClaimPaymentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    retryClaimPaymentRaw(requestParameters: RetryClaimPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * retry claim payment
     */
    retryClaimPayment(requestParameters: RetryClaimPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Checks search
     * @param {string} size 
     * @param {string} page 
     * @param {string} [searchValue] 
     * @param {string} [issuedDateFrom] 
     * @param {string} [issuedDateTo] 
     * @param {'PENDING' | 'ISSUED' | 'CLEARED' | 'VOIDED' | 'EXPIRED' | 'EXPIRING' | 'REISSUING' | 'VOIDING' | 'REISSUE_REQUIRED' | 'RETURNED'} [checkStatusTypes] 
     * @param {string} [organizationId] Employer organization id
     * @param {string} [sort] Sort criteria field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    searchChecksRaw(requestParameters: SearchChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IChecksResponseAggregatorDtoPage>>;

    /**
     * Checks search
     */
    searchChecks(requestParameters: SearchChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IChecksResponseAggregatorDtoPage>;

    /**
     * 
     * @param {string} [submitDateFrom] 
     * @param {string} [submitDateTo] 
     * @param {string} [planCodes] 
     * @param {'FPS' | 'API' | 'UI' | 'RECURRING' | 'SCHEDULED'} [contributionSource] 
     * @param {string} [page] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    searchContributionsRaw(requestParameters: SearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionRequestInfoAggregateDto>>;

    /**
     */
    searchContributions(requestParameters: SearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionRequestInfoAggregateDto>;

    /**
     * 
     * @summary Search file actors
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    searchFileActorsRaw(requestParameters: SearchFileActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IFileActorDto>>>;

    /**
     * Search file actors
     */
    searchFileActors(requestParameters: SearchFileActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IFileActorDto>>;

    /**
     * 
     * @summary Files search
     * @param {string} page 
     * @param {string} size 
     * @param {string} [searchValue] 
     * @param {string} [uploadedBy] 
     * @param {string} [fileType] Comma separated string of file_type field
     * @param {string} [fileProcessingStatusType] Comma separated string of file_processing_status_type field
     * @param {string} [createdDateFrom] 
     * @param {string} [createdDateTo] 
     * @param {string} [duplicateFileId] 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    searchFilesRaw(requestParameters: SearchFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Files search
     */
    searchFiles(requestParameters: SearchFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Select investment funding
     * @param {IFundingPatchDto} [iFundingPatchDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    selectingInvestmentFundingRaw(requestParameters: SelectingInvestmentFundingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Select investment funding
     */
    selectingInvestmentFunding(requestParameters: SelectingInvestmentFundingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Select investment path
     * @param {boolean} termsAccepted 
     * @param {IInvestmentOperationRequestDto} [iInvestmentOperationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    selectingInvestmentPathRaw(requestParameters: SelectingInvestmentPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Select investment path
     */
    selectingInvestmentPath(requestParameters: SelectingInvestmentPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Create Sequence and propagate org id
     * @param {ISequenceDto} [iSequenceDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    sequenceCreationRaw(requestParameters: SequenceCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>>;

    /**
     * Create Sequence and propagate org id
     */
    sequenceCreation(requestParameters: SequenceCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto>;

    /**
     * 
     * @summary Sign Up new user
     * @param {ISignUpRequestDto} [iSignUpRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    signUpRaw(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Sign Up new user
     */
    signUp(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Start claim repayment processing
     * @param {string} claimId Claim ID
     * @param {IClaimRepaymentStartDto} [iClaimRepaymentStartDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    startClaimRepaymentRaw(requestParameters: StartClaimRepaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Start claim repayment processing
     */
    startClaimRepayment(requestParameters: StartClaimRepaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Start Investments
     * @param {string} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    startInvestmentsRaw(requestParameters: StartInvestmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Start Investments
     */
    startInvestments(requestParameters: StartInvestmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Mark employee record as bad data and hide it from searches
     * @param {string} employeeId 
     * @param {IEmployeeBadRecordRequestDto} [iEmployeeBadRecordRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    submitHideBadDataRaw(requestParameters: SubmitHideBadDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Mark employee record as bad data and hide it from searches
     */
    submitHideBadData(requestParameters: SubmitHideBadDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary create manual contribution
     * @param {IAggregatorManualContributionRequestDto} [iAggregatorManualContributionRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    submitManualContributionRaw(requestParameters: SubmitManualContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionSegmentResponseDto>>>;

    /**
     * create manual contribution
     */
    submitManualContribution(requestParameters: SubmitManualContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionSegmentResponseDto>>;

    /**
     * 
     * @summary Switch investment model
     * @param {IInvestmentModelSwitchDto} [iInvestmentModelSwitchDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    switchInvestmentModelRaw(requestParameters: SwitchInvestmentModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Switch investment model
     */
    switchInvestmentModel(requestParameters: SwitchInvestmentModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Trade investments
     * @param {ITradeCreateDto} [iTradeCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    tradesRaw(requestParameters: TradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Trade investments
     */
    trades(requestParameters: TradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List of accounts available for transfer by employee
     * @param {string} employeeId Employee id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    transferAccountsByEmployeeRaw(requestParameters: TransferAccountsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimTransferAccountDto>>>;

    /**
     * List of accounts available for transfer by employee
     */
    transferAccountsByEmployee(requestParameters: TransferAccountsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimTransferAccountDto>>;

    /**
     * 
     * @summary Transfer funds paid for claim
     * @param {string} claimId Claim ID
     * @param {IClaimTransferCreateBatchDto} [iClaimTransferCreateBatchDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    transferClaimRaw(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Transfer funds paid for claim
     */
    transferClaim(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink templates
     * @param {string} planId Template ID
     * @param {string} [organizationId] Partner ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    unlinkTemplatesRaw(requestParameters: UnlinkTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink templates
     */
    unlinkTemplates(requestParameters: UnlinkTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update auto-investment scheduler
     * @param {IAutoInvestmentSchedulerUpdateDto} [iAutoInvestmentSchedulerUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateAutoInvestmentSchedulerRaw(requestParameters: UpdateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>>;

    /**
     * Update auto-investment scheduler
     */
    updateAutoInvestmentScheduler(requestParameters: UpdateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto>;

    /**
     * 
     * @summary Update Dependent
     * @param {string} dependentId Dependent ID
     * @param {string} [updateCardHolder] Update card holder
     * @param {IDependentInfoDto} [iDependentInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateDependentRaw(requestParameters: UpdateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>>;

    /**
     * Update Dependent
     */
    updateDependent(requestParameters: UpdateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto>;

    /**
     * 
     * @summary Update Dependent
     * @param {string} dependentId Dependent ID
     * @param {string} [updateCardHolder] Update card holder
     * @param {IDependentUpdateDto} [iDependentUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateDependent1Raw(requestParameters: UpdateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>>;

    /**
     * Update Dependent
     */
    updateDependent1(requestParameters: UpdateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto>;

    /**
     * 
     * @summary Update Employee
     * @param {string} employeeId Employee ID
     * @param {IEmployeeInfoUpdateDto} [iEmployeeInfoUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateEmployeeRaw(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>>;

    /**
     * Update Employee
     */
    updateEmployee(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto>;

    /**
     * 
     * @summary Update employer termination properties for organization
     * @param {string} organizationId Organization ID
     * @param {IEmployerTerminationPropertiesV3Dto} [iEmployerTerminationPropertiesV3Dto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateEmployerTerminationProperties1Raw(requestParameters: UpdateEmployerTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>>;

    /**
     * Update employer termination properties for organization
     */
    updateEmployerTerminationProperties1(requestParameters: UpdateEmployerTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto>;

    /**
     * 
     * @summary Update express setup JSON record
     * @param {string} organizationId Organization ID
     * @param {IExpressSetupDto} [iExpressSetupDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateExpressSetupRaw(requestParameters: UpdateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>>;

    /**
     * Update express setup JSON record
     */
    updateExpressSetup(requestParameters: UpdateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto>;

    /**
     * 
     * @summary Update express setup status
     * @param {string} organizationId Organization ID
     * @param {'DRAFT' | 'ACTIVE' | 'ABANDONED' | 'PENDING_ACTIVE' | 'ADVANCED_SETUP'} status Express setup status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateExpressSetupStatusRaw(requestParameters: UpdateExpressSetupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>>;

    /**
     * Update express setup status
     */
    updateExpressSetupStatus(requestParameters: UpdateExpressSetupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto>;

    /**
     * 
     * @summary Update lockbox
     * @param {string} lockboxId Lockbox ID
     * @param {IUpdateLockboxAggregatorDto} [iUpdateLockboxAggregatorDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateLockboxRaw(requestParameters: UpdateLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>>;

    /**
     * Update lockbox
     */
    updateLockbox(requestParameters: UpdateLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto>;

    /**
     * 
     * @summary Get Payment Methods
     * @param {string} id 
     * @param {string} [fiservAccessToken] 
     * @param {IUpdatePaymentMethodRequestDto} [iUpdatePaymentMethodRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updatePaymentMethodRaw(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>>;

    /**
     * Get Payment Methods
     */
    updatePaymentMethod(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto>;

    /**
     * 
     * @summary Update status Recurring Contribution
     * @param {string} id Recurring Contribution ID
     * @param {IRecurringContributionPatchUpdateRequestDto} [iRecurringContributionPatchUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    updateStatusRecurringContributionRaw(requestParameters: UpdateStatusRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionResponseDto>>;

    /**
     * Update status Recurring Contribution
     */
    updateStatusRecurringContribution(requestParameters: UpdateStatusRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionResponseDto>;

    /**
     * 
     * @summary Verify User Card
     * @param {string} [last4] Card last4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    verifyUserCardRaw(requestParameters: VerifyUserCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Verify User Card
     */
    verifyUserCard(requestParameters: VerifyUserCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Void check by id
     * @param {string} checkId 
     * @param {ICheckVoidDto} iCheckVoidDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    voidCheckByIdRaw(requestParameters: VoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Void check by id
     */
    voidCheckById(requestParameters: VoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Payment Methods
     * @param {string} id 
     * @param {string} [fiservAccessToken] 
     * @param {IFiservCardVaultToken} [iFiservCardVaultToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorServiceApiInterface
     */
    wireCardToRecipientRaw(requestParameters: WireCardToRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>>;

    /**
     * Get Payment Methods
     */
    wireCardToRecipient(requestParameters: WireCardToRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto>;

}

/**
 * 
 */
export class ApiAggregatorServiceApi extends runtime.BaseAPI implements ApiAggregatorServiceApiInterface {

    /**
     * create employee contribution
     */
    async acceptEmployeeContributionRaw(requestParameters: AcceptEmployeeContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEeContributionResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/employee`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEeContributionRequestDtoToJSON(requestParameters['iEeContributionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEeContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * create employee contribution
     */
    async acceptEmployeeContribution(requestParameters: AcceptEmployeeContributionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEeContributionResponseDto> {
        const response = await this.acceptEmployeeContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search account activities
     */
    async accountActivitiesRaw(requestParameters: AccountActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedAccountActivityDto>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling accountActivities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/accounts/{account-id}`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAggregatedAccountActivityDtoFromJSON));
    }

    /**
     * Search account activities
     */
    async accountActivities(requestParameters: AccountActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedAccountActivityDto>> {
        const response = await this.accountActivitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search account activities pageable
     */
    async accountActivitiesPageableRaw(requestParameters: AccountActivitiesPageableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedAccountActivityDto>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling accountActivitiesPageable().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling accountActivitiesPageable().'
            );
        }

        if (requestParameters['size'] == null) {
            throw new runtime.RequiredError(
                'size',
                'Required parameter "size" was null or undefined when calling accountActivitiesPageable().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = requestParameters['periodFrom'];
        }

        if (requestParameters['periodTo'] != null) {
            queryParameters['period_to'] = requestParameters['periodTo'];
        }

        if (requestParameters['transactionTypes'] != null) {
            queryParameters['transaction_types'] = requestParameters['transactionTypes'];
        }

        if (requestParameters['memo'] != null) {
            queryParameters['memo'] = requestParameters['memo'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/activities/accounts/{account-id}`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAggregatedAccountActivityDtoFromJSON));
    }

    /**
     * Search account activities pageable
     */
    async accountActivitiesPageable(requestParameters: AccountActivitiesPageableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedAccountActivityDto>> {
        const response = await this.accountActivitiesPageableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account orders
     */
    async accountOrdersRaw(requestParameters: AccountOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountOrderDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['serviceId'] != null) {
            queryParameters['service_id'] = requestParameters['serviceId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = requestParameters['serviceOn'];
        }

        if (requestParameters['claimValue'] != null) {
            queryParameters['claim_value'] = requestParameters['claimValue'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-orders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountOrderDtoFromJSON(jsonValue));
    }

    /**
     * Get account orders
     */
    async accountOrders(requestParameters: AccountOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountOrderDto> {
        const response = await this.accountOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account orders services
     */
    async accountOrdersServicesRaw(requestParameters: AccountOrdersServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountOrderMatrixDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = requestParameters['serviceOn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-orders/services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountOrderMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Get account orders services
     */
    async accountOrdersServices(requestParameters: AccountOrdersServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountOrderMatrixDto> {
        const response = await this.accountOrdersServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get card purses by employee id
     */
    async cardPursesRaw(requestParameters: CardPursesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICardPurseDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling cardPurses().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/card-purses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICardPurseDtoFromJSON));
    }

    /**
     * Get card purses by employee id
     */
    async cardPurses(requestParameters: CardPursesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICardPurseDto>> {
        const response = await this.cardPursesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change Claim Document
     */
    async changeClaimDocumentRaw(requestParameters: ChangeClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling changeClaimDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/document`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentIdDtoToJSON(requestParameters['iDocumentIdDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Change Claim Document
     */
    async changeClaimDocument(requestParameters: ChangeClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto> {
        const response = await this.changeClaimDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change Claim Document by Link
     */
    async changeClaimDocumentByLinkRaw(requestParameters: ChangeClaimDocumentByLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrivateClaimInfoResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling changeClaimDocumentByLink().'
            );
        }

        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling changeClaimDocumentByLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/claims/{claim-id}/documents/one-time-links/{hash-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"hash-id"}}`, encodeURIComponent(String(requestParameters['hashId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPrivateClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Change Claim Document by Link
     */
    async changeClaimDocumentByLink(requestParameters: ChangeClaimDocumentByLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrivateClaimInfoResponseDto> {
        const response = await this.changeClaimDocumentByLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CIP identity verification
     */
    async cipIdologyIdentificationRaw(requestParameters: CipIdologyIdentificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idology/identification`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipIdologyResponseDtoFromJSON(jsonValue));
    }

    /**
     * CIP identity verification
     */
    async cipIdologyIdentification(requestParameters: CipIdologyIdentificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto> {
        const response = await this.cipIdologyIdentificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims Search
     */
    async claimsSearchRaw(requestParameters: ClaimsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsResponseAggregatorDtoPage>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling claimsSearch().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling claimsSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['categoryType'] != null) {
            queryParameters['category_type'] = requestParameters['categoryType'];
        }

        if (requestParameters['claimStatus'] != null) {
            queryParameters['claim_status'] = requestParameters['claimStatus'];
        }

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = requestParameters['periodFrom'];
        }

        if (requestParameters['periodTo'] != null) {
            queryParameters['period_to'] = requestParameters['periodTo'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['externalIdentifier'] != null) {
            queryParameters['external_identifier'] = requestParameters['externalIdentifier'];
        }

        if (requestParameters['paymentType'] != null) {
            queryParameters['payment_type'] = requestParameters['paymentType'];
        }

        if (requestParameters['onlyMyAssignments'] != null) {
            queryParameters['only_my_assignments'] = requestParameters['onlyMyAssignments'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['direct'] != null) {
            queryParameters['direct'] = requestParameters['direct'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['showOnlyEscalated'] != null) {
            queryParameters['show_only_escalated'] = requestParameters['showOnlyEscalated'];
        }

        if (requestParameters['isAppealed'] != null) {
            queryParameters['is_appealed'] = requestParameters['isAppealed'];
        }

        if (requestParameters['isAppealProcessed'] != null) {
            queryParameters['is_appeal_processed'] = requestParameters['isAppealProcessed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsResponseAggregatorDtoPageFromJSON(jsonValue));
    }

    /**
     * Claims Search
     */
    async claimsSearch(requestParameters: ClaimsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsResponseAggregatorDtoPage> {
        const response = await this.claimsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create auto-investment scheduler
     */
    async createAutoInvestmentSchedulerRaw(requestParameters: CreateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investment-schedulers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IAutoInvestmentSchedulerRequestDtoToJSON(requestParameters['iAutoInvestmentSchedulerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAutoInvestmentSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create auto-investment scheduler
     */
    async createAutoInvestmentScheduler(requestParameters: CreateAutoInvestmentSchedulerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto> {
        const response = await this.createAutoInvestmentSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Carrier config
     */
    async createCarrierConfigRaw(requestParameters: CreateCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigResponseAggregatorDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carrier-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateCarrierConfigAggregatorDtoToJSON(requestParameters['iCreateCarrierConfigAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierConfigResponseAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Create Carrier config
     */
    async createCarrierConfig(requestParameters: CreateCarrierConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigResponseAggregatorDto> {
        const response = await this.createCarrierConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Claim
     */
    async createClaimRaw(requestParameters: CreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateClaimAggregatorDtoToJSON(requestParameters['iCreateClaimAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Claim
     */
    async createClaim(requestParameters: CreateClaimRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto> {
        const response = await this.createClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create coverage
     */
    async createCoverageRaw(requestParameters: CreateCoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICoverageDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/coverages`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICoverageDtoToJSON(requestParameters['iCoverageDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICoverageDtoFromJSON(jsonValue));
    }

    /**
     * Create coverage
     */
    async createCoverage(requestParameters: CreateCoverageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICoverageDto> {
        const response = await this.createCoverageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create debit card payment method
     */
    async createDebitCardPaymentMethodRaw(requestParameters: CreateDebitCardPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/debit-card`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateDebitCardRequestToJSON(requestParameters['iCreateDebitCardRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create debit card payment method
     */
    async createDebitCardPaymentMethod(requestParameters: CreateDebitCardPaymentMethodRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodResponseDto> {
        const response = await this.createDebitCardPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Dependent
     */
    async createDependentRaw(requestParameters: CreateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['updateCardHolder'] != null) {
            queryParameters['update_card_holder'] = requestParameters['updateCardHolder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDependentInfoDtoToJSON(requestParameters['iDependentInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentInfoDtoFromJSON(jsonValue));
    }

    /**
     * Create Dependent
     */
    async createDependent(requestParameters: CreateDependentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto> {
        const response = await this.createDependentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Dependent
     */
    async createDependent1Raw(requestParameters: CreateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['updateCardHolder'] != null) {
            queryParameters['update_card_holder'] = requestParameters['updateCardHolder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDependentRequestDtoToJSON(requestParameters['iDependentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Dependent
     */
    async createDependent1(requestParameters: CreateDependent1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto> {
        const response = await this.createDependent1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create document
     */
    async createDocumentRaw(requestParameters: CreateDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateDocumentAggregatorDtoToJSON(requestParameters['iCreateDocumentAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentIdDtoFromJSON(jsonValue));
    }

    /**
     * Create document
     */
    async createDocument(requestParameters: CreateDocumentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto> {
        const response = await this.createDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Employee
     */
    async createEmployeeRaw(requestParameters: CreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeInfoCreateAggregatorDtoToJSON(requestParameters['iEmployeeInfoCreateAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Employee
     */
    async createEmployee(requestParameters: CreateEmployeeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto> {
        const response = await this.createEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create employer termination properties for organization
     */
    async createEmployerTerminationPropertiesRaw(requestParameters: CreateEmployerTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createEmployerTerminationProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/organizations/{organization-id}/termination`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployerTerminationPropertiesCreateDtoToJSON(requestParameters['iEmployerTerminationPropertiesCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployerTerminationPropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Create employer termination properties for organization
     */
    async createEmployerTerminationProperties(requestParameters: CreateEmployerTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto> {
        const response = await this.createEmployerTerminationPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create employer termination properties for organization
     */
    async createEmployerTerminationProperties2Raw(requestParameters: CreateEmployerTerminationProperties2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createEmployerTerminationProperties2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/termination`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployerTerminationPropertiesV3DtoToJSON(requestParameters['iEmployerTerminationPropertiesV3Dto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployerTerminationPropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Create employer termination properties for organization
     */
    async createEmployerTerminationProperties2(requestParameters: CreateEmployerTerminationProperties2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto> {
        const response = await this.createEmployerTerminationProperties2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new express setup together with organization
     */
    async createExpressSetupRaw(requestParameters: CreateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/express-setups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationInfoDtoToJSON(requestParameters['iOrganizationInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpressSetupDtoFromJSON(jsonValue));
    }

    /**
     * Create new express setup together with organization
     */
    async createExpressSetup(requestParameters: CreateExpressSetupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto> {
        const response = await this.createExpressSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new payment account
     */
    async createNewPaymentAccountRaw(requestParameters: CreateNewPaymentAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentAccountResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-account`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPaymentAccountRequestDtoToJSON(requestParameters['iPaymentAccountRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentAccountResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create new payment account
     */
    async createNewPaymentAccount(requestParameters: CreateNewPaymentAccountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentAccountResponseDto> {
        const response = await this.createNewPaymentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Recurring Contribution or Update recurring contribution by employeeId
     */
    async createOrUpdateRecurringContributionRaw(requestParameters: CreateOrUpdateRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionAggregateResponseDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling createOrUpdateRecurringContribution().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling createOrUpdateRecurringContribution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recurring-contributions`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IRecurringContributionAggregatorRequestDtoToJSON(requestParameters['iRecurringContributionAggregatorRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecurringContributionAggregateResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Recurring Contribution or Update recurring contribution by employeeId
     */
    async createOrUpdateRecurringContribution(requestParameters: CreateOrUpdateRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionAggregateResponseDto | null | undefined > {
        const response = await this.createOrUpdateRecurringContributionRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return await response.value();
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Create processing rule
     */
    async createProcessingRuleRaw(requestParameters: CreateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IProcessingRuleDtoToJSON(requestParameters['iProcessingRuleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProcessingRuleDtoFromJSON(jsonValue));
    }

    /**
     * Create processing rule
     */
    async createProcessingRule(requestParameters: CreateProcessingRuleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto> {
        const response = await this.createProcessingRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create provider
     */
    async createProviderRaw(requestParameters: CreateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/providers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateProviderAggregatorDtoToJSON(requestParameters['iCreateProviderAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProviderInfoDtoFromJSON(jsonValue));
    }

    /**
     * Create provider
     */
    async createProvider(requestParameters: CreateProviderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto> {
        const response = await this.createProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create enrollment matrix and propagate org path
     */
    async enrollmentMatrixCreationRaw(requestParameters: EnrollmentMatrixCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollment-matrixes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEnrollmentMatrixDtoToJSON(requestParameters['iEnrollmentMatrixDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEnrollmentMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Create enrollment matrix and propagate org path
     */
    async enrollmentMatrixCreation(requestParameters: EnrollmentMatrixCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto> {
        const response = await this.enrollmentMatrixCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active payroll calendar by id
     */
    async getActivePayrollCalendarByIdRaw(requestParameters: GetActivePayrollCalendarByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedAggregatorResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getActivePayrollCalendarById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/payroll-calendars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarExtendedAggregatorResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get active payroll calendar by id
     */
    async getActivePayrollCalendarById(requestParameters: GetActivePayrollCalendarByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedAggregatorResponseDto> {
        const response = await this.getActivePayrollCalendarByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active payroll calendars by org id
     */
    async getActivePayrollCalendarsByOrgIdRaw(requestParameters: GetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarAggregatorResponseDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getActivePayrollCalendarsByOrgId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/payroll-calendars/organizations/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayrollCalendarAggregatorResponseDtoFromJSON));
    }

    /**
     * Get active payroll calendars by org id
     */
    async getActivePayrollCalendarsByOrgId(requestParameters: GetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarAggregatorResponseDto>> {
        const response = await this.getActivePayrollCalendarsByOrgIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Collect all monitor contribution info
     */
    async getAllMonitorContributionInfoRaw(requestParameters: GetAllMonitorContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMonitorContributionAggregateResponseDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAllMonitorContributionInfo().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getAllMonitorContributionInfo().'
            );
        }

        if (requestParameters['taxYear'] == null) {
            throw new runtime.RequiredError(
                'taxYear',
                'Required parameter "taxYear" was null or undefined when calling getAllMonitorContributionInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['taxYear'] != null) {
            queryParameters['tax_year'] = requestParameters['taxYear'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/monitor-contribution/info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IMonitorContributionAggregateResponseDtoFromJSON(jsonValue));
    }

    /**
     * Collect all monitor contribution info
     */
    async getAllMonitorContributionInfo(requestParameters: GetAllMonitorContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMonitorContributionAggregateResponseDto> {
        const response = await this.getAllMonitorContributionInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Collect and get all ACTIVE or PAUSED recurring contribution info
     */
    async getAllRecurringContributionInfoRaw(requestParameters: GetAllRecurringContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionAggregateResponseDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAllRecurringContributionInfo().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getAllRecurringContributionInfo().'
            );
        }

        if (requestParameters['taxYear'] == null) {
            throw new runtime.RequiredError(
                'taxYear',
                'Required parameter "taxYear" was null or undefined when calling getAllRecurringContributionInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['taxYear'] != null) {
            queryParameters['tax_year'] = requestParameters['taxYear'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recurring-contributions/info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecurringContributionAggregateResponseDtoFromJSON(jsonValue));
    }

    /**
     * Collect and get all ACTIVE or PAUSED recurring contribution info
     */
    async getAllRecurringContributionInfo(requestParameters: GetAllRecurringContributionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionAggregateResponseDto> {
        const response = await this.getAllRecurringContributionInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get balance reminder banner info
     */
    async getBalanceReminderBannerInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceReminderResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/balance-reminder`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IBalanceReminderResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get balance reminder banner info
     */
    async getBalanceReminderBannerInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceReminderResponseDto> {
        const response = await this.getBalanceReminderBannerInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Carrier config with organization name
     */
    async getCarrierConfigDetailsRaw(requestParameters: GetCarrierConfigDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigResponseAggregatorDtoPage>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['purposeTypes'] != null) {
            queryParameters['purpose_types'] = requestParameters['purposeTypes'];
        }

        if (requestParameters['statusType'] != null) {
            queryParameters['status_type'] = requestParameters['statusType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carrier-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierConfigResponseAggregatorDtoPageFromJSON(jsonValue));
    }

    /**
     * Get Carrier config with organization name
     */
    async getCarrierConfigDetails(requestParameters: GetCarrierConfigDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigResponseAggregatorDtoPage | null | undefined > {
        const response = await this.getCarrierConfigDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get claim based activity details
     */
    async getClaimActivityDetailsRaw(requestParameters: GetClaimActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivityDetails>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimActivityDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/claims/{claimId}`;
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimActivityDetailsFromJSON(jsonValue));
    }

    /**
     * Get claim based activity details
     */
    async getClaimActivityDetails(requestParameters: GetClaimActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivityDetails> {
        const response = await this.getClaimActivityDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim by id
     */
    async getClaimByIdRaw(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoAggregatorResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoAggregatorResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get claim by id
     */
    async getClaimById(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoAggregatorResponseDto> {
        const response = await this.getClaimByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claim Payment Details
     */
    async getClaimPaymentDetailsRaw(requestParameters: GetClaimPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentDetailsResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimPaymentDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claim_id'] = requestParameters['claimId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/payment-details`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Claim Payment Details
     */
    async getClaimPaymentDetails(requestParameters: GetClaimPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentDetailsResponseDto | null | undefined > {
        const response = await this.getClaimPaymentDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get claim related card swipes
     */
    async getClaimRelatedCardSwipesRaw(requestParameters: GetClaimRelatedCardSwipesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IRelatedClaimEnhancedDto>>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimRelatedCardSwipes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/related-card-swipes`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IRelatedClaimEnhancedDtoFromJSON));
    }

    /**
     * Get claim related card swipes
     */
    async getClaimRelatedCardSwipes(requestParameters: GetClaimRelatedCardSwipesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IRelatedClaimEnhancedDto>> {
        const response = await this.getClaimRelatedCardSwipesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get irs limits for contribution by employeesId and planId
     */
    async getEmployeesIrsLimitsRaw(requestParameters: GetEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeContributionLimitResponse>>> {
        if (requestParameters['taxYear'] == null) {
            throw new runtime.RequiredError(
                'taxYear',
                'Required parameter "taxYear" was null or undefined when calling getEmployeesIrsLimits().'
            );
        }

        if (requestParameters['employeePlanPairs'] == null) {
            throw new runtime.RequiredError(
                'employeePlanPairs',
                'Required parameter "employeePlanPairs" was null or undefined when calling getEmployeesIrsLimits().'
            );
        }

        if (requestParameters['size'] == null) {
            throw new runtime.RequiredError(
                'size',
                'Required parameter "size" was null or undefined when calling getEmployeesIrsLimits().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getEmployeesIrsLimits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['taxYear'] != null) {
            queryParameters['tax_year'] = requestParameters['taxYear'];
        }

        if (requestParameters['employeePlanPairs'] != null) {
            queryParameters['employee_plan_pairs'] = requestParameters['employeePlanPairs'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contribution-requests/irs-limits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEmployeeContributionLimitResponseFromJSON));
    }

    /**
     * Get irs limits for contribution by employeesId and planId
     */
    async getEmployeesIrsLimits(requestParameters: GetEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeContributionLimitResponse>> {
        const response = await this.getEmployeesIrsLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollments ordered by plan\'s accountType,asc, validFrom,desc
     */
    async getEnrollmentsRaw(requestParameters: GetEnrollmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnrollmentDto>>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['accountStatus'] != null) {
            queryParameters['account_status'] = requestParameters['accountStatus'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnrollmentDtoFromJSON));
    }

    /**
     * Get enrollments ordered by plan\'s accountType,asc, validFrom,desc
     */
    async getEnrollments(requestParameters: GetEnrollmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnrollmentDto>> {
        const response = await this.getEnrollmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get file errors
     */
    async getErrorsRaw(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileRecordErrorAggregatorDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getErrors().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}/records/errors`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileRecordErrorAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Get file errors
     */
    async getErrors(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileRecordErrorAggregatorDto> {
        const response = await this.getErrorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get file errors in CSV format
     */
    async getErrorsCsvRaw(requestParameters: GetErrorsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getErrorsCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}/errors-csv`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get file errors in CSV format
     */
    async getErrorsCsv(requestParameters: GetErrorsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getErrorsCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get express setup JSON record
     */
    async getExpressSetupRaw(requestParameters: GetExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupExtendedDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getExpressSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/express-setups/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpressSetupExtendedDtoFromJSON(jsonValue));
    }

    /**
     * Get express setup JSON record
     */
    async getExpressSetup(requestParameters: GetExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupExtendedDto> {
        const response = await this.getExpressSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get file details by id
     */
    async getFileDetailsByIdRaw(requestParameters: GetFileDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileDetailsAggregatorResponseDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getFileDetailsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}/details`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileDetailsAggregatorResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get file details by id
     */
    async getFileDetailsById(requestParameters: GetFileDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileDetailsAggregatorResponseDto> {
        const response = await this.getFileDetailsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve investments holdings.
     */
    async getInvestmentHoldingsRaw(requestParameters: GetInvestmentHoldingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestmentHoldingsDto>> {
        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/holdings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestmentHoldingsDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve investments holdings.
     */
    async getInvestmentHoldings(requestParameters: GetInvestmentHoldingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestmentHoldingsDto> {
        const response = await this.getInvestmentHoldingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invoices details by invoice id
     */
    async getInvoiceDetailsByIdRaw(requestParameters: GetInvoiceDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceDetailsAggregatorDto>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling getInvoiceDetailsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/invoices/{invoice-id}/details-view`;
        urlPath = urlPath.replace(`{${"invoice-id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceDetailsAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Get invoices details by invoice id
     */
    async getInvoiceDetailsById(requestParameters: GetInvoiceDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceDetailsAggregatorDto> {
        const response = await this.getInvoiceDetailsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve lockbox details by id
     */
    async getLockboxDetailsRaw(requestParameters: GetLockboxDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDetailsAggregatorDto>> {
        if (requestParameters['lockboxId'] == null) {
            throw new runtime.RequiredError(
                'lockboxId',
                'Required parameter "lockboxId" was null or undefined when calling getLockboxDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/{lockbox-id}`;
        urlPath = urlPath.replace(`{${"lockbox-id"}}`, encodeURIComponent(String(requestParameters['lockboxId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxDetailsAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve lockbox details by id
     */
    async getLockboxDetails(requestParameters: GetLockboxDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDetailsAggregatorDto> {
        const response = await this.getLockboxDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve lockbox employee details by employee id
     */
    async getLockboxEmployeeDetailsRaw(requestParameters: GetLockboxEmployeeDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDetailsAggregatorDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getLockboxEmployeeDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/matched-employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxDetailsAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve lockbox employee details by employee id
     */
    async getLockboxEmployeeDetails(requestParameters: GetLockboxEmployeeDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDetailsAggregatorDto> {
        const response = await this.getLockboxEmployeeDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get mobile app link from organization by one time link
     */
    async getMobileAppLinkByOneTimeLinkRaw(requestParameters: GetMobileAppLinkByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeOverridablePropertiesDto>> {
        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling getMobileAppLinkByOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/overridable-properties/by-one-time-links/{hash-id}`;
        urlPath = urlPath.replace(`{${"hash-id"}}`, encodeURIComponent(String(requestParameters['hashId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IQrCodeOverridablePropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Get mobile app link from organization by one time link
     */
    async getMobileAppLinkByOneTimeLink(requestParameters: GetMobileAppLinkByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeOverridablePropertiesDto> {
        const response = await this.getMobileAppLinkByOneTimeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get mobile app link from organization by qr code
     */
    async getMobileAppLinkByQrCodeRaw(requestParameters: GetMobileAppLinkByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeOverridablePropertiesDto>> {
        if (requestParameters['qrId'] == null) {
            throw new runtime.RequiredError(
                'qrId',
                'Required parameter "qrId" was null or undefined when calling getMobileAppLinkByQrCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/overridable-properties/by-qr-codes/{qr-id}`;
        urlPath = urlPath.replace(`{${"qr-id"}}`, encodeURIComponent(String(requestParameters['qrId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IQrCodeOverridablePropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Get mobile app link from organization by qr code
     */
    async getMobileAppLinkByQrCode(requestParameters: GetMobileAppLinkByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeOverridablePropertiesDto> {
        const response = await this.getMobileAppLinkByQrCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notification template variables
     */
    async getNotificationTemplateVariablesRaw(requestParameters: GetNotificationTemplateVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNotificationTemplateVariables().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/external-templates/{id}/variables`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get notification template variables
     */
    async getNotificationTemplateVariables(requestParameters: GetNotificationTemplateVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getNotificationTemplateVariablesRaw(requestParameters, initOverrides);
    }

    /**
     * Get pageable organizations
     */
    async getPageableOrganizationsRaw(requestParameters: GetPageableOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationExpressSetupResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['organizationIds'] != null) {
            queryParameters['organization_ids'] = requestParameters['organizationIds'];
        }

        if (requestParameters['partnerId'] != null) {
            queryParameters['partner_id'] = requestParameters['partnerId'];
        }

        if (requestParameters['parentId'] != null) {
            queryParameters['parent_id'] = requestParameters['parentId'];
        }

        if (requestParameters['parentIds'] != null) {
            queryParameters['parent_ids'] = requestParameters['parentIds'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationExpressSetupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get pageable organizations
     */
    async getPageableOrganizations(requestParameters: GetPageableOrganizationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationExpressSetupResponseDto> {
        const response = await this.getPageableOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plan renewals
     */
    async getPlanRenewalsRaw(requestParameters: GetPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRenewalRecordExtendedDto>> {
        if (requestParameters['planYearId'] == null) {
            throw new runtime.RequiredError(
                'planYearId',
                'Required parameter "planYearId" was null or undefined when calling getPlanRenewals().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/renewals/plan-year/{plan-year-id}`;
        urlPath = urlPath.replace(`{${"plan-year-id"}}`, encodeURIComponent(String(requestParameters['planYearId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRenewalRecordExtendedDtoFromJSON(jsonValue));
    }

    /**
     * Get plan renewals
     */
    async getPlanRenewals(requestParameters: GetPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRenewalRecordExtendedDto> {
        const response = await this.getPlanRenewalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get posting based activity details
     */
    async getPostingActivityDetailsRaw(requestParameters: GetPostingActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBankingActivityDetails>> {
        if (requestParameters['postingId'] == null) {
            throw new runtime.RequiredError(
                'postingId',
                'Required parameter "postingId" was null or undefined when calling getPostingActivityDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/postings/{postingId}`;
        urlPath = urlPath.replace(`{${"postingId"}}`, encodeURIComponent(String(requestParameters['postingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IBankingActivityDetailsFromJSON(jsonValue));
    }

    /**
     * Get posting based activity details
     */
    async getPostingActivityDetails(requestParameters: GetPostingActivityDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBankingActivityDetails> {
        const response = await this.getPostingActivityDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Collect prefund summary by invoice id
     */
    async getPrefundSummaryByInvoiceIdRaw(requestParameters: GetPrefundSummaryByInvoiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrefundSummaryDto>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling getPrefundSummaryByInvoiceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/prefund-histories/invoices/{invoice-id}/summary`;
        urlPath = urlPath.replace(`{${"invoice-id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPrefundSummaryDtoFromJSON(jsonValue));
    }

    /**
     * Collect prefund summary by invoice id
     */
    async getPrefundSummaryByInvoiceId(requestParameters: GetPrefundSummaryByInvoiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrefundSummaryDto> {
        const response = await this.getPrefundSummaryByInvoiceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rejected claim info by claim id
     */
    async getRejectedClaimInfoRaw(requestParameters: GetRejectedClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimRejectedAggregatorDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getRejectedClaimInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/rejected-claim`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimRejectedAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Get rejected claim info by claim id
     */
    async getRejectedClaimInfo(requestParameters: GetRejectedClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimRejectedAggregatorDto> {
        const response = await this.getRejectedClaimInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get renewals
     */
    async getRenewalsRaw(requestParameters: GetRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IRenewalRecordExtendedDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getRenewals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/renewals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IRenewalRecordExtendedDtoFromJSON));
    }

    /**
     * Get renewals
     */
    async getRenewals(requestParameters: GetRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IRenewalRecordExtendedDto>> {
        const response = await this.getRenewalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get repayment claims info
     */
    async getRepaymentMatchesClaimsInfoRaw(requestParameters: GetRepaymentMatchesClaimsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimRepaymentAggregatedDto>> {
        if (requestParameters['searchValue'] == null) {
            throw new runtime.RequiredError(
                'searchValue',
                'Required parameter "searchValue" was null or undefined when calling getRepaymentMatchesClaimsInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/repayment/matches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimRepaymentAggregatedDtoFromJSON(jsonValue));
    }

    /**
     * Get repayment claims info
     */
    async getRepaymentMatchesClaimsInfo(requestParameters: GetRepaymentMatchesClaimsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimRepaymentAggregatedDto> {
        const response = await this.getRepaymentMatchesClaimsInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create health plan and propagate orgId
     */
    async healthPlanCreationRaw(requestParameters: HealthPlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IHealthPlanCreateDtoToJSON(requestParameters['iHealthPlanCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHealthPlanDtoFromJSON(jsonValue));
    }

    /**
     * Create health plan and propagate orgId
     */
    async healthPlanCreation(requestParameters: HealthPlanCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanDto> {
        const response = await this.healthPlanCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update health plan
     */
    async healthPlanUpdateRaw(requestParameters: HealthPlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanDto>> {
        if (requestParameters['healthPlanId'] == null) {
            throw new runtime.RequiredError(
                'healthPlanId',
                'Required parameter "healthPlanId" was null or undefined when calling healthPlanUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/{health-plan-id}`;
        urlPath = urlPath.replace(`{${"health-plan-id"}}`, encodeURIComponent(String(requestParameters['healthPlanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IHealthPlanUpdateDtoToJSON(requestParameters['iHealthPlanUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHealthPlanDtoFromJSON(jsonValue));
    }

    /**
     * Update health plan
     */
    async healthPlanUpdate(requestParameters: HealthPlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanDto> {
        const response = await this.healthPlanUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search invoices for dashboard
     */
    async invoiceDashboardRaw(requestParameters: InvoiceDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceDashboardPageDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceTypes'] != null) {
            queryParameters['invoice_types'] = requestParameters['invoiceTypes'];
        }

        if (requestParameters['achMethods'] != null) {
            queryParameters['ach_methods'] = requestParameters['achMethods'];
        }

        if (requestParameters['endedFrom'] != null) {
            queryParameters['ended_from'] = requestParameters['endedFrom'];
        }

        if (requestParameters['endedTo'] != null) {
            queryParameters['ended_to'] = requestParameters['endedTo'];
        }

        if (requestParameters['invoiceStatusTypes'] != null) {
            queryParameters['invoice_status_types'] = requestParameters['invoiceStatusTypes'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/invoices/dashboard`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceDashboardPageDtoFromJSON(jsonValue));
    }

    /**
     * Search invoices for dashboard
     */
    async invoiceDashboard(requestParameters: InvoiceDashboardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceDashboardPageDto> {
        const response = await this.invoiceDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for organization logo and enrollments
     */
    async linkedEmployeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAggregatedEmployeeLinkedAccountsDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/linked-accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAggregatedEmployeeLinkedAccountsDtoFromJSON));
    }

    /**
     * Search for organization logo and enrollments
     */
    async linkedEmployees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAggregatedEmployeeLinkedAccountsDto>> {
        const response = await this.linkedEmployeesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Match employees by search value
     */
    async matchEmployeesRaw(requestParameters: MatchEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMatchDetailsAggregatorDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/matches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeMatchDetailsAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Match employees by search value
     */
    async matchEmployees(requestParameters: MatchEmployeesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMatchDetailsAggregatorDto> {
        const response = await this.matchEmployeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve extended employee info
     */
    async matchEmployees1Raw(requestParameters: MatchEmployees1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMatchDetailsAggregatorDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling matchEmployees1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees/{employee-id}/extended`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeMatchDetailsAggregatorDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve extended employee info
     */
    async matchEmployees1(requestParameters: MatchEmployees1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMatchDetailsAggregatorDto> {
        const response = await this.matchEmployees1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async openaiOcrReaderRaw(requestParameters: OpenaiOcrReaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling openaiOcrReader().'
            );
        }

        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling openaiOcrReader().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hashId'] != null) {
            queryParameters['hash_id'] = requestParameters['hashId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/documents/files/by-link/{file-id}/openai/ocr/matching`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrClaimDtoFromJSON(jsonValue));
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async openaiOcrReader(requestParameters: OpenaiOcrReaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto> {
        const response = await this.openaiOcrReaderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Openai ocr reader
     */
    async openaiOcrReader1Raw(requestParameters: OpenaiOcrReader1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling openaiOcrReader1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}/ocr-reader`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrClaimDtoFromJSON(jsonValue));
    }

    /**
     * Openai ocr reader
     */
    async openaiOcrReader1(requestParameters: OpenaiOcrReader1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto> {
        const response = await this.openaiOcrReader1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async openaiOcrReader2Raw(requestParameters: OpenaiOcrReader2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrClaimDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling openaiOcrReader2().'
            );
        }

        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling openaiOcrReader2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claim_id'] = requestParameters['claimId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}/openai/ocr/matching`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrClaimDtoFromJSON(jsonValue));
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async openaiOcrReader2(requestParameters: OpenaiOcrReader2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrClaimDto> {
        const response = await this.openaiOcrReader2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Organization lock
     */
    async organizationLockRaw(requestParameters: OrganizationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationLock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-locks/lock/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationLockDtoFromJSON(jsonValue));
    }

    /**
     * Organization lock
     */
    async organizationLock(requestParameters: OrganizationLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto> {
        const response = await this.organizationLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Organization unlock
     */
    async organizationUnlockRaw(requestParameters: OrganizationUnlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUnlock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-locks/unlock/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationLockDtoFromJSON(jsonValue));
    }

    /**
     * Organization unlock
     */
    async organizationUnlock(requestParameters: OrganizationUnlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto> {
        const response = await this.organizationUnlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update system templates for organizations
     */
    async patchLinkedSystemTemplatesRaw(requestParameters: PatchLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling patchLinkedSystemTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/templates/organizations/{organization-id}/linked-templates`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IPatchLinkedSystemTemplatesDtoToJSON(requestParameters['iPatchLinkedSystemTemplatesDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update system templates for organizations
     */
    async patchLinkedSystemTemplates(requestParameters: PatchLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchLinkedSystemTemplatesRaw(requestParameters, initOverrides);
    }

    /**
     * Patch plan renewal by plan year id
     */
    async patchPlanRenewalsRaw(requestParameters: PatchPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRenewalRecordDto>> {
        if (requestParameters['planYearId'] == null) {
            throw new runtime.RequiredError(
                'planYearId',
                'Required parameter "planYearId" was null or undefined when calling patchPlanRenewals().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/renewals/plan-year/{plan-year-id}`;
        urlPath = urlPath.replace(`{${"plan-year-id"}}`, encodeURIComponent(String(requestParameters['planYearId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRenewalRecordDtoFromJSON(jsonValue));
    }

    /**
     * Patch plan renewal by plan year id
     */
    async patchPlanRenewals(requestParameters: PatchPlanRenewalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRenewalRecordDto> {
        const response = await this.patchPlanRenewalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Payment Method Setup
     */
    async paymentMethodSetupRaw(requestParameters: PaymentMethodSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPaymentMethodSetupRequestDtoToJSON(requestParameters['iPaymentMethodSetupRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodSetupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Payment Method Setup
     */
    async paymentMethodSetup(requestParameters: PaymentMethodSetupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto> {
        const response = await this.paymentMethodSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Payment Methods
     */
    async paymentMethodsGetRaw(requestParameters: PaymentMethodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPaymentMethodSetupResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['paymentMethodType'] != null) {
            queryParameters['payment_method_type'] = requestParameters['paymentMethodType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPaymentMethodSetupResponseDtoFromJSON));
    }

    /**
     * Get Payment Methods
     */
    async paymentMethodsGet(requestParameters: PaymentMethodsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPaymentMethodSetupResponseDto>> {
        const response = await this.paymentMethodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create plan and propagate org id
     */
    async planCreationRaw(requestParameters: PlanCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanDtoToJSON(requestParameters['iPlanDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanDtoFromJSON(jsonValue));
    }

    /**
     * Create plan and propagate org id
     */
    async planCreation(requestParameters: PlanCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto> {
        const response = await this.planCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete plan/template by id
     */
    async planDeleteRaw(requestParameters: PlanDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete plan/template by id
     */
    async planDelete(requestParameters: PlanDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete plan termination properties by plan id
     */
    async planTerminationPropertiesDeleteRaw(requestParameters: PlanTerminationPropertiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planTerminationPropertiesDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/termination-properties`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete plan termination properties by plan id
     */
    async planTerminationPropertiesDelete(requestParameters: PlanTerminationPropertiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planTerminationPropertiesDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Updates plan by id
     */
    async planUpdateRaw(requestParameters: PlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanDtoToJSON(requestParameters['iPlanDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanDtoFromJSON(jsonValue));
    }

    /**
     * Updates plan by id
     */
    async planUpdate(requestParameters: PlanUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto> {
        const response = await this.planUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates plan year by id
     */
    async planYearRaw(requestParameters: PlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>> {
        if (requestParameters['planYearId'] == null) {
            throw new runtime.RequiredError(
                'planYearId',
                'Required parameter "planYearId" was null or undefined when calling planYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/{plan-year-id}`;
        urlPath = urlPath.replace(`{${"plan-year-id"}}`, encodeURIComponent(String(requestParameters['planYearId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanYearDtoToJSON(requestParameters['iPlanYearDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanYearDtoFromJSON(jsonValue));
    }

    /**
     * Updates plan year by id
     */
    async planYear(requestParameters: PlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto> {
        const response = await this.planYearRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create plan year and propagate org id
     */
    async planYearCreationRaw(requestParameters: PlanYearCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanYearDtoToJSON(requestParameters['iPlanYearDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanYearDtoFromJSON(jsonValue));
    }

    /**
     * Create plan year and propagate org id
     */
    async planYearCreation(requestParameters: PlanYearCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto> {
        const response = await this.planYearCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process single enrollment record
     */
    async processEnrollmentRaw(requestParameters: ProcessEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IProcessEnrollmentRequestDtoToJSON(requestParameters['iProcessEnrollmentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEnrollmentRecordDtoFromJSON(jsonValue));
    }

    /**
     * Process single enrollment record
     */
    async processEnrollment(requestParameters: ProcessEnrollmentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentRecordDto> {
        const response = await this.processEnrollmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process single enrollment record for a health plan
     */
    async processHealthPlanEnrollmentRaw(requestParameters: ProcessHealthPlanEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans-enrollments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IProcessEnrollmentRequestDtoToJSON(requestParameters['iProcessEnrollmentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEnrollmentRecordDtoFromJSON(jsonValue));
    }

    /**
     * Process single enrollment record for a health plan
     */
    async processHealthPlanEnrollment(requestParameters: ProcessHealthPlanEnrollmentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentRecordDto> {
        const response = await this.processHealthPlanEnrollmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reissue check by id
     */
    async reissueCheckByIdRaw(requestParameters: ReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling reissueCheckById().'
            );
        }

        if (requestParameters['iCheckReissueDto'] == null) {
            throw new runtime.RequiredError(
                'iCheckReissueDto',
                'Required parameter "iCheckReissueDto" was null or undefined when calling reissueCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/checks/{check-id}/reissue`;
        urlPath = urlPath.replace(`{${"check-id"}}`, encodeURIComponent(String(requestParameters['checkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICheckReissueDtoToJSON(requestParameters['iCheckReissueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reissue check by id
     */
    async reissueCheckById(requestParameters: ReissueCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reissueCheckByIdRaw(requestParameters, initOverrides);
    }

    /**
     * retry claim payment
     */
    async retryClaimPaymentRaw(requestParameters: RetryClaimPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/retry-payment`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IRetryClaimPaymentDtoToJSON(requestParameters['iRetryClaimPaymentDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * retry claim payment
     */
    async retryClaimPayment(requestParameters: RetryClaimPaymentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryClaimPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Checks search
     */
    async searchChecksRaw(requestParameters: SearchChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IChecksResponseAggregatorDtoPage>> {
        if (requestParameters['size'] == null) {
            throw new runtime.RequiredError(
                'size',
                'Required parameter "size" was null or undefined when calling searchChecks().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling searchChecks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['issuedDateFrom'] != null) {
            queryParameters['issued_date_from'] = requestParameters['issuedDateFrom'];
        }

        if (requestParameters['issuedDateTo'] != null) {
            queryParameters['issued_date_to'] = requestParameters['issuedDateTo'];
        }

        if (requestParameters['checkStatusTypes'] != null) {
            queryParameters['check_status_types'] = requestParameters['checkStatusTypes'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/checks/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IChecksResponseAggregatorDtoPageFromJSON(jsonValue));
    }

    /**
     * Checks search
     */
    async searchChecks(requestParameters: SearchChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IChecksResponseAggregatorDtoPage> {
        const response = await this.searchChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchContributionsRaw(requestParameters: SearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionRequestInfoAggregateDto>> {
        const queryParameters: any = {};

        if (requestParameters['submitDateFrom'] != null) {
            queryParameters['submit_date_from'] = requestParameters['submitDateFrom'];
        }

        if (requestParameters['submitDateTo'] != null) {
            queryParameters['submit_date_to'] = requestParameters['submitDateTo'];
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['contributionSource'] != null) {
            queryParameters['contribution_source'] = requestParameters['contributionSource'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contribution-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionRequestInfoAggregateDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchContributions(requestParameters: SearchContributionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionRequestInfoAggregateDto> {
        const response = await this.searchContributionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search file actors
     */
    async searchFileActorsRaw(requestParameters: SearchFileActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IFileActorDto>>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/files/file-actors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IFileActorDtoFromJSON));
    }

    /**
     * Search file actors
     */
    async searchFileActors(requestParameters: SearchFileActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IFileActorDto>> {
        const response = await this.searchFileActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Files search
     */
    async searchFilesRaw(requestParameters: SearchFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling searchFiles().'
            );
        }

        if (requestParameters['size'] == null) {
            throw new runtime.RequiredError(
                'size',
                'Required parameter "size" was null or undefined when calling searchFiles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['uploadedBy'] != null) {
            queryParameters['uploaded_by'] = requestParameters['uploadedBy'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }

        if (requestParameters['fileProcessingStatusType'] != null) {
            queryParameters['file_processing_status_type'] = requestParameters['fileProcessingStatusType'];
        }

        if (requestParameters['createdDateFrom'] != null) {
            queryParameters['created_date_from'] = requestParameters['createdDateFrom'];
        }

        if (requestParameters['createdDateTo'] != null) {
            queryParameters['created_date_to'] = requestParameters['createdDateTo'];
        }

        if (requestParameters['duplicateFileId'] != null) {
            queryParameters['duplicate_file_id'] = requestParameters['duplicateFileId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Files search
     */
    async searchFiles(requestParameters: SearchFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.searchFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Select investment funding
     */
    async selectingInvestmentFundingRaw(requestParameters: SelectingInvestmentFundingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/flows/funding`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IFundingPatchDtoToJSON(requestParameters['iFundingPatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Select investment funding
     */
    async selectingInvestmentFunding(requestParameters: SelectingInvestmentFundingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.selectingInvestmentFundingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Select investment path
     */
    async selectingInvestmentPathRaw(requestParameters: SelectingInvestmentPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        if (requestParameters['termsAccepted'] == null) {
            throw new runtime.RequiredError(
                'termsAccepted',
                'Required parameter "termsAccepted" was null or undefined when calling selectingInvestmentPath().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['termsAccepted'] != null) {
            queryParameters['terms_accepted'] = requestParameters['termsAccepted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/flows/path`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IInvestmentOperationRequestDtoToJSON(requestParameters['iInvestmentOperationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Select investment path
     */
    async selectingInvestmentPath(requestParameters: SelectingInvestmentPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.selectingInvestmentPathRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Sequence and propagate org id
     */
    async sequenceCreationRaw(requestParameters: SequenceCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sequences`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ISequenceDtoToJSON(requestParameters['iSequenceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISequenceDtoFromJSON(jsonValue));
    }

    /**
     * Create Sequence and propagate org id
     */
    async sequenceCreation(requestParameters: SequenceCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto> {
        const response = await this.sequenceCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sign Up new user
     */
    async signUpRaw(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/signup`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ISignUpRequestDtoToJSON(requestParameters['iSignUpRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sign Up new user
     */
    async signUp(requestParameters: SignUpRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.signUpRaw(requestParameters, initOverrides);
    }

    /**
     * Start claim repayment processing
     */
    async startClaimRepaymentRaw(requestParameters: StartClaimRepaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling startClaimRepayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/start-repayment`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimRepaymentStartDtoToJSON(requestParameters['iClaimRepaymentStartDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start claim repayment processing
     */
    async startClaimRepayment(requestParameters: StartClaimRepaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startClaimRepaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Start Investments
     */
    async startInvestmentsRaw(requestParameters: StartInvestmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/flows/start`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Start Investments
     */
    async startInvestments(requestParameters: StartInvestmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.startInvestmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark employee record as bad data and hide it from searches
     */
    async submitHideBadDataRaw(requestParameters: SubmitHideBadDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling submitHideBadData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/bad-data`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeBadRecordRequestDtoToJSON(requestParameters['iEmployeeBadRecordRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark employee record as bad data and hide it from searches
     */
    async submitHideBadData(requestParameters: SubmitHideBadDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitHideBadDataRaw(requestParameters, initOverrides);
    }

    /**
     * create manual contribution
     */
    async submitManualContributionRaw(requestParameters: SubmitManualContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionSegmentResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/manual-contribution`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IAggregatorManualContributionRequestDtoToJSON(requestParameters['iAggregatorManualContributionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContributionSegmentResponseDtoFromJSON));
    }

    /**
     * create manual contribution
     */
    async submitManualContribution(requestParameters: SubmitManualContributionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionSegmentResponseDto>> {
        const response = await this.submitManualContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Switch investment model
     */
    async switchInvestmentModelRaw(requestParameters: SwitchInvestmentModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investors/investment-models`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IInvestmentModelSwitchDtoToJSON(requestParameters['iInvestmentModelSwitchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Switch investment model
     */
    async switchInvestmentModel(requestParameters: SwitchInvestmentModelRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.switchInvestmentModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trade investments
     */
    async tradesRaw(requestParameters: TradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/trades`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITradeCreateDtoToJSON(requestParameters['iTradeCreateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Trade investments
     */
    async trades(requestParameters: TradesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tradesRaw(requestParameters, initOverrides);
    }

    /**
     * List of accounts available for transfer by employee
     */
    async transferAccountsByEmployeeRaw(requestParameters: TransferAccountsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimTransferAccountDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling transferAccountsByEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transfer/employees/{employee-id}/accounts`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IClaimTransferAccountDtoFromJSON));
    }

    /**
     * List of accounts available for transfer by employee
     */
    async transferAccountsByEmployee(requestParameters: TransferAccountsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimTransferAccountDto>> {
        const response = await this.transferAccountsByEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Transfer funds paid for claim
     */
    async transferClaimRaw(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling transferClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transfer/claims/{claim-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimTransferCreateBatchDtoToJSON(requestParameters['iClaimTransferCreateBatchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Transfer funds paid for claim
     */
    async transferClaim(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.transferClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink templates
     */
    async unlinkTemplatesRaw(requestParameters: UnlinkTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling unlinkTemplates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/templates/{plan-id}/unlinking`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink templates
     */
    async unlinkTemplates(requestParameters: UnlinkTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkTemplatesRaw(requestParameters, initOverrides);
    }

    /**
     * Update auto-investment scheduler
     */
    async updateAutoInvestmentSchedulerRaw(requestParameters: UpdateAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investment-schedulers`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IAutoInvestmentSchedulerUpdateDtoToJSON(requestParameters['iAutoInvestmentSchedulerUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAutoInvestmentSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update auto-investment scheduler
     */
    async updateAutoInvestmentScheduler(requestParameters: UpdateAutoInvestmentSchedulerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto> {
        const response = await this.updateAutoInvestmentSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Dependent
     */
    async updateDependentRaw(requestParameters: UpdateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling updateDependent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['updateCardHolder'] != null) {
            queryParameters['update_card_holder'] = requestParameters['updateCardHolder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents/{dependent-id}`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IDependentInfoDtoToJSON(requestParameters['iDependentInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentInfoDtoFromJSON(jsonValue));
    }

    /**
     * Update Dependent
     */
    async updateDependent(requestParameters: UpdateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto> {
        const response = await this.updateDependentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Dependent
     */
    async updateDependent1Raw(requestParameters: UpdateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling updateDependent1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['updateCardHolder'] != null) {
            queryParameters['update_card_holder'] = requestParameters['updateCardHolder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/{dependent-id}`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IDependentUpdateDtoToJSON(requestParameters['iDependentUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update Dependent
     */
    async updateDependent1(requestParameters: UpdateDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto> {
        const response = await this.updateDependent1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Employee
     */
    async updateEmployeeRaw(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeInfoUpdateDtoToJSON(requestParameters['iEmployeeInfoUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update Employee
     */
    async updateEmployee(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto> {
        const response = await this.updateEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update employer termination properties for organization
     */
    async updateEmployerTerminationProperties1Raw(requestParameters: UpdateEmployerTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateEmployerTerminationProperties1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/termination`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployerTerminationPropertiesV3DtoToJSON(requestParameters['iEmployerTerminationPropertiesV3Dto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployerTerminationPropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Update employer termination properties for organization
     */
    async updateEmployerTerminationProperties1(requestParameters: UpdateEmployerTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto> {
        const response = await this.updateEmployerTerminationProperties1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update express setup JSON record
     */
    async updateExpressSetupRaw(requestParameters: UpdateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateExpressSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/express-setups/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IExpressSetupDtoToJSON(requestParameters['iExpressSetupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpressSetupDtoFromJSON(jsonValue));
    }

    /**
     * Update express setup JSON record
     */
    async updateExpressSetup(requestParameters: UpdateExpressSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto> {
        const response = await this.updateExpressSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update express setup status
     */
    async updateExpressSetupStatusRaw(requestParameters: UpdateExpressSetupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateExpressSetupStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling updateExpressSetupStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/express-setups/{organization-id}/status`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpressSetupDtoFromJSON(jsonValue));
    }

    /**
     * Update express setup status
     */
    async updateExpressSetupStatus(requestParameters: UpdateExpressSetupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupDto> {
        const response = await this.updateExpressSetupStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update lockbox
     */
    async updateLockboxRaw(requestParameters: UpdateLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>> {
        if (requestParameters['lockboxId'] == null) {
            throw new runtime.RequiredError(
                'lockboxId',
                'Required parameter "lockboxId" was null or undefined when calling updateLockbox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/{lockbox-id}`;
        urlPath = urlPath.replace(`{${"lockbox-id"}}`, encodeURIComponent(String(requestParameters['lockboxId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateLockboxAggregatorDtoToJSON(requestParameters['iUpdateLockboxAggregatorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxDtoFromJSON(jsonValue));
    }

    /**
     * Update lockbox
     */
    async updateLockbox(requestParameters: UpdateLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto> {
        const response = await this.updateLockboxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Payment Methods
     */
    async updatePaymentMethodRaw(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['fiservAccessToken'] != null) {
            headerParameters['Fiserv-Access-Token'] = String(requestParameters['fiservAccessToken']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdatePaymentMethodRequestDtoToJSON(requestParameters['iUpdatePaymentMethodRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodSetupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Payment Methods
     */
    async updatePaymentMethod(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto> {
        const response = await this.updatePaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update status Recurring Contribution
     */
    async updateStatusRecurringContributionRaw(requestParameters: UpdateStatusRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStatusRecurringContribution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recurring-contributions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IRecurringContributionPatchUpdateRequestDtoToJSON(requestParameters['iRecurringContributionPatchUpdateRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecurringContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update status Recurring Contribution
     */
    async updateStatusRecurringContribution(requestParameters: UpdateStatusRecurringContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionResponseDto> {
        const response = await this.updateStatusRecurringContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify User Card
     */
    async verifyUserCardRaw(requestParameters: VerifyUserCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['last4'] != null) {
            queryParameters['last4'] = requestParameters['last4'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/verify`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Verify User Card
     */
    async verifyUserCard(requestParameters: VerifyUserCardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyUserCardRaw(requestParameters, initOverrides);
    }

    /**
     * Void check by id
     */
    async voidCheckByIdRaw(requestParameters: VoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling voidCheckById().'
            );
        }

        if (requestParameters['iCheckVoidDto'] == null) {
            throw new runtime.RequiredError(
                'iCheckVoidDto',
                'Required parameter "iCheckVoidDto" was null or undefined when calling voidCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/checks/{check-id}/void`;
        urlPath = urlPath.replace(`{${"check-id"}}`, encodeURIComponent(String(requestParameters['checkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICheckVoidDtoToJSON(requestParameters['iCheckVoidDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Void check by id
     */
    async voidCheckById(requestParameters: VoidCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.voidCheckByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Get Payment Methods
     */
    async wireCardToRecipientRaw(requestParameters: WireCardToRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentMethodSetupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling wireCardToRecipient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['fiservAccessToken'] != null) {
            headerParameters['Fiserv-Access-Token'] = String(requestParameters['fiservAccessToken']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payment-methods/{id}/card`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IFiservCardVaultTokenToJSON(requestParameters['iFiservCardVaultToken']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentMethodSetupResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Payment Methods
     */
    async wireCardToRecipient(requestParameters: WireCardToRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentMethodSetupResponseDto> {
        const response = await this.wireCardToRecipientRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetEnrollmentsAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEnrollmentsStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPageableOrganizationsTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPageableOrganizationsStatusesEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum InvoiceDashboardAchMethodsEnum {
    NONE = 'NONE',
    PUSH = 'PUSH',
    PULL = 'PULL'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchChecksCheckStatusTypesEnum {
    PENDING = 'PENDING',
    ISSUED = 'ISSUED',
    CLEARED = 'CLEARED',
    VOIDED = 'VOIDED',
    EXPIRED = 'EXPIRED',
    EXPIRING = 'EXPIRING',
    REISSUING = 'REISSUING',
    VOIDING = 'VOIDING',
    REISSUE_REQUIRED = 'REISSUE_REQUIRED',
    RETURNED = 'RETURNED'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchContributionsContributionSourceEnum {
    FPS = 'FPS',
    API = 'API',
    UI = 'UI',
    RECURRING = 'RECURRING',
    SCHEDULED = 'SCHEDULED'
}
/**
  * @export
  * @enum {string}
  */
export enum UpdateExpressSetupStatusStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ABANDONED = 'ABANDONED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    ADVANCED_SETUP = 'ADVANCED_SETUP'
}
